<p-toast></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<p-overlayPanel #panelNavigationDirecte>
	<ng-template pTemplate>
		<input #champNavigationDirecte id="numero" type="text" pInputText [(ngModel)]="numeroNavigationDirecte"
			(keyup.enter)="confirmerNavigationDirecte()">
	</ng-template>
</p-overlayPanel>

<p-card *ngIf="!EstCharge()">
	<div class="fluid formgrid grid">
		<div class="flex flex-column gap-2 my-2 col-12 text-center">
			<p-progressSpinner></p-progressSpinner>
		</div>
	</div>
</p-card>

<div *ngIf="EstCharge()" class="grid">

	<div class="col-12">
		<p-card>
			<div class="flex align-items-center gap-4 mb-4">
				<div *ngIf="!photoPrincipale"
					class="w-6rem h-6rem bg-gray-100 border-round flex align-items-center justify-content-center">
					<i class="pi pi-image text-gray-500"></i>
				</div>
				<img *ngIf="photoPrincipale" class="w-6rem h-6rem border-round" [src]="photoPrincipale.previewUrl"
					alt="Image de l'item">
				<div class="mt-2">
					<div class="flex align-items-center gap-3 mb-1">
						<h5 class="m-0">{{item.value().numero}}</h5>
						<span [class]="'statut ' + item.value().statut.nom.toLowerCase()">
							{{item.value().statut.nom}}
						</span>
						<h5 *ngIf="item.value().estLie" class="m-0">
							<i class="pi pi-link" style="font-size: 1rem"></i> Lié avec
							{{item.value().parent}}
							<i class="pi pi-eye ml-3" style="font-size: 1rem; color: #689F38; cursor: pointer;"
								(click)="ouvrirItemLie($event)"></i>
						</h5>
					</div>
					<div class="flex align-items-center gap-1 mb-1">
						<i *ngIf="item.value().produitDangereux" class="pi pi-exclamation-triangle text-yellow-500 mr-2"
							style="font-size: 1.2rem;" pTooltip="Produit Dangereux">
						</i>
						<span class="text-lg">{{item.value().description}}</span>
						<app-bouton-favori [titrePage]="titrePagePrincipale" [type]="eTypeFavori"></app-bouton-favori>
						<span *ngIf="modeApercu">
							<i class="pi pi-id-card ml-4"></i>
							<a class="lienFicheComplete" (click)="ouvrirFicheComplete()">Aller à la fiche complète</a>
						</span>
					</div>
				</div>
			</div>
			<p-menubar autoDisplay="false" [model]="menu" *ngIf="!modeApercu">
				<app-document-lock *ngIf="estAutorise('item_modifier')" [id]="itemId.toString()"
					[eTypeLien]="ETypeLienDocument.Item" [isModifying]="modeAjoutModification()"
					(modifyStatusChange)="btnModifier_click()" (saveRequested)="enregistrerModifications()"
					(cancelRequested)="annulerModification($event)">
				</app-document-lock>
			</p-menubar>
		</p-card>
	</div>


</div>


<div *ngIf="EstCharge()" class="grid">
	<div class="col-12">
		<p-tabView [scrollable]="true" #tabView [(activeIndex)]="tabIndex" orientation="left"
				(onChange)="surChangementOnglet($event)">


				<!-- #region Infos générales  -->
				<p-tabPanel header="Informations générales" leftIcon="pi pi-info-circle">
					<p-card>
					<div class="grid">

						<!-- QR Code Section -->
						<div class="col-12" style="overflow: hidden;">
							<div class="flex justify-content-end align-items-center">
								<div class="flex gap-2">
									<p-button [label]="printFormat === 'normal' ? 'Format: Normal' : 'Format: P-touch'"
										[icon]="printFormat === 'normal' ? 'pi pi-file' : 'pi pi-tablet'"
										class="p-button-sm p-button-outlined" *ngIf="showQrCode"
										(onClick)="togglePrintFormat()">
									</p-button>
									<p-button label="Imprimer" icon="pi pi-print" class="p-button-sm" *ngIf="showQrCode"
										(onClick)="printQrCodeSection()">
									</p-button>
									<p-button [label]="showQrCode ? 'Masquer QR' : 'Afficher QR'"
										[icon]="showQrCode ? 'pi pi-eye-slash' : 'pi pi-qrcode'"
										class="p-button-sm p-button-outlined" (onClick)="toggleQrCode()">
									</p-button>
								</div>
							</div>

							<div *ngIf="showQrCode" id="qr-print-section"
								[ngClass]="printFormat === 'normal' ? 'qr-section' : 'qr-section qr-section-ptouch'">

								<!-- Content wrapper for P-touch horizontal layout -->
								<div class="qr-content-wrapper"
									[ngClass]="printFormat === 'ptouch' ? 'qr-content-horizontal' : ''">
									<div class="item-info">
										<div class="item-number">{{item.value().numero}}</div>
										<div class="item-description">{{item.value().description}}</div>
										<div class="item-category">{{item.value().categorie?.nom}}</div>
									</div>
									<div class="qr-code">
										<qrcode [qrdata]="qrCodeData" [width]="printFormat === 'normal' ? 200 : 120"
											[errorCorrectionLevel]="'M'" [colorDark]="'#000000'"
											[colorLight]="'#FFFFFF'">
										</qrcode>
									</div>
								</div>
								<div class="format-indicator">
									<p class="m-0 text-xs">
										<i class="pi"
											[ngClass]="printFormat === 'normal' ? 'pi-file' : 'pi-tablet'"></i>
										Format d'impression: {{printFormat === 'normal' ? 'Normal (papier standard)' :
										'P-touch (étiquette horizontale)'}}
									</p>
								</div>
							</div>
						</div>

						<!-- Left column - General Information -->
						<div class="col-12 lg:col-6">
							<p-card styleClass="h-full">
								<h6 class="mb-4 text-primary-600 font-semibold">Informations générales</h6>
								<div class="flex flex-column gap-4">
									<div class="sihc-field flex flex-column gap-2">
										<label for="numero" class="font-semibold">Numéro<span
												class="requis">*</span></label>
										<span *ngIf="modeConsultation()" class="text-900">{{item.value().numero}}</span>
										<input *ngIf="!modeConsultation()" id="numero" type="text" pInputText
											[readonly]="true" [(ngModel)]="item.value().numero">
									</div>
									<div class="sihc-field flex flex-column gap-2">
										<label for="description" class="font-semibold">Description<span
												class="requis">*</span></label>
										<span *ngIf="modeConsultation()"
											class="text-900">{{item.value().description}}</span>
										<input *ngIf="!modeConsultation()" id="description" type="text" pInputText
											[readonly]="modeConsultation()" [(ngModel)]="item.value().description">
										<small class="p-error" *ngIf="submitted && !item.value().description">La
											description
											est
											obligatoire.</small>
									</div>
									<div *ngIf="item.value().categorie.estUnique"
										class="sihc-field flex flex-column gap-2">
										<label for="compagnie" class="font-medium">Compagnie<span
												class="requis">*</span></label>
										<span *ngIf="modeConsultation()" class="text-900">
											<app-compagnie-label [compagnie]="item.value().compagnie"></app-compagnie-label>
											<span *ngIf="!item.value().compagnie">Non spécifiée</span>
										</span>
										<p-dropdown *ngIf="!modeConsultation()" [options]="listeCompagnies"
											[(ngModel)]="item.value().compagnie" optionLabel="nom"
											[readonly]="modeConsultation()" appendTo="body" filter="true" filterBy="nom"
											placeholder="Sélectionnez une compagnie...">
											<ng-template pTemplate="selectedItem">
												<app-compagnie-label *ngIf="item.value().compagnie"
													[compagnie]="item.value().compagnie"></app-compagnie-label>
											</ng-template>
											<ng-template let-compagnie pTemplate="item">
												<app-compagnie-label [compagnie]="compagnie"></app-compagnie-label>
											</ng-template>
										</p-dropdown>
										<small class="p-error" *ngIf="submitted && !item.value().compagnie">La compagnie
											est
											obligatoire.</small>
									</div>
									<div class="sihc-field flex flex-column gap-2">
										<label for="categorie" class="font-semibold">Catégorie<span
												class="requis">*</span></label>
										<span *ngIf="modeConsultation()" class="text-900">{{item.value().categorie?.nom
											|| 'Non spécifiée'}}</span>
										<p-dropdown *ngIf="!modeConsultation()" [(ngModel)]="item.value().categorie"
											inputId="categorie" [options]="listeCategories"
											(onChange)="surSelectionCategorie()" [readonly]="modeConsultation()"
											optionLabel="nom" placeholder="Sélectionnez..." appendTo="body">
											<ng-template pTemplate="selectedItem">
												<div *ngIf="item.value().categorie">
													<div>{{item.value().categorie.nom}}</div>
												</div>
											</ng-template>
											<ng-template let-option pTemplate="item">
												<div>
													<div>{{option.nom}}</div>
												</div>
											</ng-template>
										</p-dropdown>
										<small class="p-error" *ngIf="submitted && !item.value().categorie">La catégorie
											est
											obligatoire.</small>
									</div>
									<div class="sihc-field flex flex-column gap-2">
										<label for="sousCategorie" class="font-semibold">Sous-catégorie</label>
										<span *ngIf="modeConsultation()"
											class="text-900">{{item.value().sousCategorie?.nom || 'Non
											spécifiée'}}</span>
										<p-dropdown *ngIf="!modeConsultation()" [options]="listeSousCategories"
											[(ngModel)]="item.value().sousCategorie" optionLabel="nom" appendTo="body"
											filter="true" filterBy="nom" [readonly]="modeConsultation()"
											placeholder="Sélectionnez une sous-catégorie...">
											<ng-template pTemplate="selectedItem">
												<div>{{item.value().sousCategorie?.nom}}</div>
											</ng-template>
											<ng-template let-sousCategorie pTemplate="item">
												<div>
													<div>{{sousCategorie?.nom}}</div>
												</div>
											</ng-template>
										</p-dropdown>
									</div>
									<div class="sihc-field flex flex-column gap-2">
										<label for="marque" class="font-semibold">Marque</label>
										<span *ngIf="modeConsultation()" class="text-900">{{item.value().marque || 'Non
											spécifiée'}}</span>
										<input *ngIf="!modeConsultation()" id="marque" type="text" pInputText
											[readonly]="modeConsultation()" [(ngModel)]="item.value().marque">
									</div>
									<div class="sihc-field flex flex-column gap-2">
										<label for="modele" class="font-semibold">Modèle</label>
										<span *ngIf="modeConsultation()" class="text-900">{{item.value().modele || 'Non
											spécifié'}}</span>
										<input *ngIf="!modeConsultation()" id="modele" type="text" pInputText
											[readonly]="modeConsultation()" [(ngModel)]="item.value().modele">
									</div>
									<div *ngIf="item.value().categorie?.categorieId === 3"
										class="sihc-field flex flex-column gap-2">
										<label for="produitDangereux" class="font-semibold">Produit Dangereux</label>
										<span *ngIf="modeConsultation()" class="text-900">
											<i class="pi"
												[ngClass]="item.value().produitDangereux ? 'pi-check text-green-600' : 'pi-times text-red-600'"></i>
											{{item.value().produitDangereux ? 'Oui' : 'Non'}}
										</span>
										<p-toggleButton *ngIf="!modeConsultation()"
											[(ngModel)]="item.value().produitDangereux" [disabled]="modeConsultation()"
											onLabel="Oui" offLabel="Non"></p-toggleButton>
									</div>
									<div *ngIf="item.value().categorie.estUnique"
										class="sihc-field flex flex-column gap-2">
										<label for="emplacement" class="font-semibold">Assigné à</label>
										<span *ngIf="item.value().employe" class="text-900"><i
												class="pi pi-user mr-2"></i> <a
												[routerLink]="'/employe/' + item.value().employe.employeId"><app-employe-avec-emplacement
													[employe]="item.value().employe"></app-employe-avec-emplacement></a></span>
										<span *ngIf="item.value().emplacement" class="text-900"><i
												class="pi pi-map-marker mr-2"></i> <a
												[routerLink]="'/emplacement/' + item.value().emplacement.emplacementId">{{item.value().emplacement
												| nomEmplacement}}</a></span>
									</div>
									<div class="sihc-field flex flex-column gap-2">
										<label for="localisation" class="font-semibold">Localisation entrepôt</label>
										<span *ngIf="modeConsultation()"
											class="text-900">{{item.value().localisation?.nom || 'Non
											spécifiée'}}</span>
										<p-dropdown *ngIf="!modeConsultation()" [(ngModel)]="item.value().localisation"
											inputId="localisation" [options]="listeLocalisations"
											[readonly]="modeConsultation()" optionLabel="nom"
											placeholder="Sélectionnez..." appendTo="body">
											<ng-template pTemplate="selectedItem">
												<div *ngIf="item.value().localisation">
													<div>{{item.value().localisation.nom}}</div>
												</div>
											</ng-template>
											<ng-template let-option pTemplate="item">
												<div>
													<div>{{option.nom}}</div>
												</div>
											</ng-template>
										</p-dropdown>
									</div>
									<div *ngIf="item.value().indSuiviMecanique"
										class="sihc-field flex flex-column gap-2">
										<label for="departementMecanique" class="font-semibold">Département
											Mécanique</label>
										<span *ngIf="modeConsultation()"
											class="text-900">{{item.value().departementMecanique?.nom || 'Non
											spécifié'}}</span>
										<p-dropdown *ngIf="!modeConsultation()" [options]="listeDepartementsMecanique"
											[(ngModel)]="item.value().departementMecanique" optionLabel="nom"
											[readonly]="modeConsultation()" appendTo="body"
											placeholder="Sélectionnez un département...">
											<ng-template pTemplate="selectedItem">
												<div *ngIf="item.value().departementMecanique">
													<div>{{item.value().departementMecanique.nom}}</div>
												</div>
											</ng-template>
											<ng-template let-departement pTemplate="item">
												<div>
													<div>{{departement.nom}}</div>
												</div>
											</ng-template>
										</p-dropdown>
									</div>
									<div *ngIf="item.value().categorie.estFacturable"
										class="sihc-field flex flex-column gap-2">
										<label for="typeFacturation" class="font-semibold">Type de facturation</label>
										<span *ngIf="modeConsultation()"
											class="text-900">{{item.value().typeFacturation?.nom || 'Non
											spécifié'}}</span>
										<p-dropdown *ngIf="!modeConsultation()"
											[(ngModel)]="item.value().typeFacturation" inputId="typeFacturation"
											[options]="listeTypesFacturation" [readonly]="modeConsultation()"
											optionLabel="nom" showClear placeholder="Sélectionnez..." appendTo="body">
											<ng-template pTemplate="selectedItem">
												<div *ngIf="item.value().typeFacturation">
													<div>{{item.value().typeFacturation.nom}}</div>
												</div>
											</ng-template>
											<ng-template let-option pTemplate="item">
												<div>
													<div>{{option.nom}}</div>
												</div>
											</ng-template>
										</p-dropdown>
									</div>
									<div *ngIf="item.value().categorie.estFacturable"
										class="sihc-field flex flex-column gap-2">
										<label for="noCtrl" class="font-semibold">Numéro CTRL</label>
										<span *ngIf="modeConsultation()" class="text-900">{{item.value().noCtrl || 'Non
											spécifié'}}</span>
										<input *ngIf="!modeConsultation()" id="noCtrl" type="text" pInputText
											[readonly]="modeConsultation()" [(ngModel)]="item.value().noCtrl">
									</div>
								</div>

								<!-- Mécanique Settings Section -->
								<div *ngIf="item.value().indSuiviMecanique" class="mt-5">
									<h6 class="mb-4 text-primary-600 font-semibold">Paramètres mécaniques</h6>
									<div class="flex flex-column gap-4">
										<div class="sihc-field sihc-field flex flex-column gap-2">
											<label class="font-semibold">Suivi des heures</label>
											<span *ngIf="modeConsultation()" class="text-900">
												<i class="pi"
													[ngClass]="item.value().indSuiviHeures ? 'pi-check text-green-600' : 'pi-times text-red-600'"></i>
												{{item.value().indSuiviHeures ? 'Oui' : 'Non'}}
											</span>
											<p-toggleButton *ngIf="!modeConsultation()"
												[(ngModel)]="item.value().indSuiviHeures" name="indSuiviHeures"
												onLabel="Oui" offLabel="Non" [binary]="true"
												[disabled]="modeConsultation()"
												(onChange)="surSuiviHeures()"></p-toggleButton>
										</div>
										<div class="sihc-field flex flex-column gap-2">
											<label class="font-semibold">Suivi des KM</label>
											<span *ngIf="modeConsultation()" class="text-900">
												<i class="pi"
													[ngClass]="item.value().indSuiviKms ? 'pi-check text-green-600' : 'pi-times text-red-600'"></i>
												{{item.value().indSuiviKms ? 'Oui' : 'Non'}}
											</span>
											<p-toggleButton *ngIf="!modeConsultation()"
												[(ngModel)]="item.value().indSuiviKms" name="indSuiviKms" onLabel="Oui"
												offLabel="Non" [binary]="true" [disabled]="modeConsultation()"
												(onChange)="surSuiviKms()"></p-toggleButton>
										</div>
										<div class="sihc-field flex flex-column gap-2">
											<label class="font-semibold">Ignorer dans le rapport de suivi des
												heures</label>
											<span *ngIf="modeConsultation()" class="text-900">
												<i class="pi"
													[ngClass]="item.value().indIgnorerRapportHeures ? 'pi-check text-green-600' : 'pi-times text-red-600'"></i>
												{{item.value().indIgnorerRapportHeures ? 'Oui' : 'Non'}}
											</span>
											<p-toggleButton *ngIf="!modeConsultation()"
												[(ngModel)]="item.value().indIgnorerRapportHeures"
												name="indIgnorerRapportHeures" onLabel="Oui" offLabel="Non"
												[binary]="true"
												[disabled]="modeConsultation() || !item.value().indSuiviHeures"></p-toggleButton>
										</div>
										<div class="sihc-field flex flex-column gap-2">
											<label class="font-semibold">Ignorer dans le rapport de suivi des KM</label>
											<span *ngIf="modeConsultation()" class="text-900">
												<i class="pi"
													[ngClass]="item.value().indIgnorerRapportKms ? 'pi-check text-green-600' : 'pi-times text-red-600'"></i>
												{{item.value().indIgnorerRapportKms ? 'Oui' : 'Non'}}
											</span>
											<p-toggleButton *ngIf="!modeConsultation()"
												[(ngModel)]="item.value().indIgnorerRapportKms"
												name="indIgnorerRapportKms" onLabel="Oui" offLabel="Non" [binary]="true"
												[disabled]="modeConsultation() || !item.value().indSuiviKms"></p-toggleButton>
										</div>
									</div>
								</div>

								<!-- Archive Information Section -->
								<div *ngIf="item.value().statut.statutId == 2" class="mt-5">
									<h6 class="mb-4 text-primary-600 font-semibold">Informations d'archivage</h6>
									<div class="flex flex-column gap-4">
										<div class="sihc-field flex flex-column gap-2">
											<label class="font-semibold">Raison d'archivage</label>
											<span class="text-900">{{item.value().raisonArchive?.nom || 'Non
												spécifiée'}}</span>
										</div>
										<div class="sihc-field flex flex-column gap-2">
											<label class="font-semibold">Commentaire d'archivage</label>
											<span class="text-900">{{item.value().commentaireArchive || 'Aucun
												commentaire'}}</span>
										</div>
									</div>
								</div>
							</p-card>
						</div>

						<!-- Right column - Attributs supplémentaires -->
						<div class="col-12 lg:col-6">
							<p-card>
								<div class="flex align-items-center justify-content-between mb-4">
									<h6 class="m-0 text-primary-600 font-semibold">Attributs supplémentaires</h6>
									<p-badge [value]="nbAttributsRenseignes + '/' + nbAttributsTotal"
										severity="primary"></p-badge>
								</div>

								<p-card *ngIf="!chargementCompleteAttributs" class="mb-3">
									<div class="flex justify-content-center py-4">
										<p-progressSpinner
											[style]="{width: '30px', height: '30px'}"></p-progressSpinner>
									</div>
								</p-card>

								<div *ngIf="chargementCompleteAttributs" class="space-y-4">
									<div *ngFor="let valeurattr of attributs">
										<div *ngIf="modeModification() || valeurattr.valeur"
											class="flex flex-column gap-2 border-bottom-1 surface-border pb-3 mb-3">
											<label class="font-medium text-sm text-700">
												{{valeurattr.attribut.nom}}
												<span *ngIf="modeConsultation() && valeurattr.attribut.indObligatoire"
													class="requis">*</span>
											</label>

											<!-- Consultation mode - display values -->
											<div *ngIf="modeConsultation()">
												<span *ngIf="valeurattr.attribut.typeChamp == 1"
													class="text-900">{{valeurattr.valeur || 'Non renseigné'}}</span>
												<span *ngIf="valeurattr.attribut.typeChamp == 2"
													class="text-900">{{valeurattr.valeur || 'Non renseigné'}}</span>
												<span *ngIf="valeurattr.attribut.typeChamp == 3"
													class="text-900">{{valeurattr.valeur || 'Non renseigné'}}</span>
												<span *ngIf="valeurattr.attribut.typeChamp == 4"
													class="text-900">{{valeurattr.valeur ? (valeurattr.valeur |
													date:'dd/MM/yyyy') : 'Non renseigné'}}</span>
												<span *ngIf="valeurattr.attribut.typeChamp == 5" class="text-900">
													<i class="pi mr-2"
														[ngClass]="valeurattr.valeur ? 'pi-check text-green-600' : 'pi-times text-red-600'"></i>
													{{valeurattr.valeur ? 'Oui' : 'Non'}}
												</span>
											</div>

											<!-- Modification mode - editable fields -->
											<div *ngIf="modeModification()">
												<input *ngIf="valeurattr.attribut.typeChamp == 1" pInputText type="text"
													[(ngModel)]="valeurattr.valeurFrontend" class="w-full">
												<p-inputNumber *ngIf="valeurattr.attribut.typeChamp == 2"
													[(ngModel)]="valeurattr.valeurFrontend" inputStyleClass="w-full">
												</p-inputNumber>
												<p-inputNumber *ngIf="valeurattr.attribut.typeChamp == 3"
													[(ngModel)]="valeurattr.valeurFrontend" mode="decimal"
													[minFractionDigits]="2" [maxFractionDigits]="5"
													inputStyleClass="w-full"></p-inputNumber>
												<p-calendar *ngIf="valeurattr.attribut.typeChamp == 4" appendTo="body"
													showIcon=true [(ngModel)]="valeurattr.valeurFrontend"
													dateFormat="dd/mm/yy" class="w-full"></p-calendar>
												<p-checkbox *ngIf="valeurattr.attribut.typeChamp == 5" [binary]="true"
													[(ngModel)]="valeurattr.valeurFrontend"></p-checkbox>
											</div>
										</div>
									</div>

									<div *ngIf="!modeModification() && nbAttributsRenseignes === 0"
										class="text-center py-6 text-500">
										<i class="pi pi-info-circle text-3xl text-300 mb-3"></i>
										<p class="m-0">Aucun attribut supplémentaire renseigné.</p>
									</div>
								</div>
							</p-card>
						</div>
					</div>
					</p-card>
				</p-tabPanel>
				<!-- #endregion -->
				<!-- #region Inventaire -->
				<p-tabPanel *ngIf="estAutorise('item_inventaire') && !item.value().categorie.estUnique"
					header="Inventaire" leftIcon="pi pi-list">
					<p-card>
					<p-menu #menuContextuelInventaire popup="popup" [model]="contenuMenuContextuelInventaire"></p-menu>

					<p-card *ngIf="!chargementCompleteInventaire">
						<div class="fluid formgrid grid">
							<div class="flex flex-column gap-2 my-2 col-12 text-center">
								<p-progressSpinner></p-progressSpinner>
							</div>
						</div>
					</p-card>

					<p-table *ngIf="chargementCompleteInventaire" [value]="item.value().inventaire" autoLayout="true"
						tableStyleClass="tableNormale" styleClass="p-datatable-striped" dataKey="inventaireId">
						<ng-template pTemplate="header">
							<tr>
								<th>Emplacement</th>
								<th>Quantité</th>
								<th style="min-width: 5rem; width: 5rem;"></th>
							</tr>
						</ng-template>
						<ng-template pTemplate="body" let-inventaire>
							<tr [pContextMenuRow]="inventaire">
								<td>
									<div class="flex align-items-center gap-2">
										<i class="pi pi-map-marker"></i>
										<div class="flex flex-column gap-2 p-2">
											<span class="font-semibold">{{inventaire.emplacement.nom}}</span>
											<span class="text-sm">{{inventaire.emplacement.code}}</span>
										</div>
									</div>
								</td>
								<td>{{inventaire.quantite}}</td>
								<td *ngIf="!modeApercu">
									<button
										*ngIf="this.estAutorise('emplacement_detail') || this.estAutorise('item_ajuster_inventaire')"
										pButton pRipple icon="pi pi-bars" class="p-button-secondary mr-2 boutonGrille"
										(click)="surMenuContextuelInventaire($event, inventaire)"></button>
								</td>
							</tr>
						</ng-template>
						<ng-template pTemplate="emptymessage">
							<tr>
								<td colspan="3">Aucun inventaire.</td>
							</tr>
						</ng-template>
					</p-table>
					</p-card>
				</p-tabPanel>
				<!-- #endregion -->
				<!-- #region Historique -->
				<p-tabPanel *ngIf="estAutorise('item_historique')"
					[header]="'Historique (' + item.value().nbEntreesHistorique + ')'" leftIcon="pi pi-calendar">
					<p-card>
					<p-menu #menuContextuelHistorique popup="popup" [model]="contenuMenuContextuelHistorique"></p-menu>

					<p-card *ngIf="!chargementCompleteHistorique">
						<div class="fluid formgrid grid">
							<div class="flex flex-column gap-2 my-2 col-12 text-center">
								<p-progressSpinner></p-progressSpinner>
							</div>
						</div>
					</p-card>

					<div *ngIf="chargementCompleteHistorique" style="max-width: 1000px; margin: 10px auto;">
						<div class="flex justify-content-center align-items-center mb-3 w-full">
							<span class="p-input-icon-left w-full">
								<i class="pi pi-search"></i>
								<input pInputText type="text" #searchInput class="w-full"
									(input)="filtrerHistorique($event.target.value)" placeholder="Recherche..." />
							</span>
						</div>

						<div *ngIf="historiqueFiltre.length === 0" class="text-center p-4 text-muted">
							Aucun historique.
						</div>

						<p-timeline *ngIf="historiqueFiltre.length > 0" [value]="historiqueFiltre" layout="vertical"
							align="left">
							<ng-template pTemplate="opposite" let-historique>
								<div *ngIf="!isMobile" class="text-sm text-500 mt-2">
									<ng-container *ngIf="historique.requisition">
										{{historique.requisition.date | date:'yyyy-MM-dd'}}
									</ng-container>
									<ng-container *ngIf="historique.emprunt">
										{{historique.emprunt.dateAffectation | date:'yyyy-MM-dd'}}
									</ng-container>
								</div>
							</ng-template>
							<ng-template pTemplate="marker" let-historique>
								<div class="flex align-items-center justify-content-center w-2rem h-2rem border-circle surface-100 shadow-2"
									[ngStyle]="{
										'color': historique.emprunt && !historique.requisition ? '#E91E63' : 
												historique.requisition?.type?.typeRequisitionId === 1 ? '#673AB7' :
												historique.requisition?.type?.typeRequisitionId === 2 ? '#4CAF50' :
												historique.requisition?.type?.typeRequisitionId === 3 ? '#FF5722' : '#000000',
										'border': '2px solid',
										'border-color': historique.emprunt && !historique.requisition ? '#E91E63' :
												historique.requisition?.type?.typeRequisitionId === 1 ? '#673AB7' :
												historique.requisition?.type?.typeRequisitionId === 2 ? '#4CAF50' :
												historique.requisition?.type?.typeRequisitionId === 3 ? '#FF5722' : '#000000'
									}">
									<i *ngIf="historique.requisition?.type?.typeRequisitionId === 1"
										class="pi pi-truck text-xs"></i>
									<i *ngIf="historique.requisition?.type?.typeRequisitionId === 2"
										class="pi pi-undo text-xs"></i>
									<i *ngIf="historique.requisition?.type?.typeRequisitionId === 3"
										class="pi pi-arrows-h text-xs"></i>
									<i *ngIf="historique.emprunt && !historique.requisition"
										class="pi pi-user text-xs"></i>
								</div>
							</ng-template>
							<ng-template pTemplate="content" let-historique>
								<p-card styleClass="mb-2">
									<!-- Requisition display -->
									<ng-container *ngIf="historique.requisition">
										<div class="flex justify-content-between align-items-start">
											<div class="flex flex-column">
												<div class="text-lg font-semibold">
													{{historique.requisition.type.nom}}
													{{historique.requisition.numero}}
												</div>
												<div *ngIf="isMobile" class="text-sm text-500 mb-2">
													<ng-container *ngIf="historique.requisition">
														{{historique.requisition.date | date:'yyyy-MM-dd'}}
													</ng-container>
												</div>
											</div>
											<p-button *ngIf="estAutorise('requisition_detail') && !modeApercu"
												icon="pi pi-eye" label="Détails" pTooltip="Voir la réquisition"
												styleClass="ml-2" text size="small"
												[routerLink]="['/transport', historique.requisition.requisitionId]"></p-button>
										</div>
										<div *ngIf="!isMobile" class="grid">
											<div class="col-12 md:col-5">
												<div class="flex align-items-center">
													<strong class="mr-2">De:</strong>
													<a
														[routerLink]="['/emplacement', historique.requisition.de.emplacementId]">{{historique.requisition.de.nom}}
														({{historique.requisition.de.code}})</a>
												</div>
											</div>
											<div class="col-12 md:col-1">
												<div class="flex align-items-center justify-content-center">
													<i class="pi pi-arrow-right"></i>
												</div>
											</div>
											<div class="col-12 md:col-5">
												<div class="flex align-items-center">
													<strong class="mr-2">À:</strong>
													<a
														[routerLink]="['/emplacement', historique.requisition.a.emplacementId]">{{historique.requisition.a.nom}}
														({{historique.requisition.a.code}})</a>
												</div>
											</div>
										</div>
										<div *ngIf="isMobile" class="flex flex-column gap-1 my-1">
											<p-chip
												label="De: {{historique.requisition.de.nom}} ({{historique.requisition.de.code}})"
												[routerLink]="['/emplacement', historique.requisition.de.emplacementId]"></p-chip>
											<p-chip
												label="À: {{historique.requisition.a.nom}} ({{historique.requisition.a.code}})"
												[routerLink]="['/emplacement', historique.requisition.a.emplacementId]"></p-chip>
										</div>
										<div class="">
											<strong>Quantité:</strong> {{historique.quantite}}
										</div>
										<div class="" *ngIf="historique.requisition.demandeur">
											<strong>Demandeur:</strong> <app-employe-avec-emplacement
												[employe]="historique.requisition.demandeur"></app-employe-avec-emplacement>
										</div>
									</ng-container>
									<!-- Emprunt display -->
									<ng-container *ngIf="historique.emprunt && !historique.requisition">
										<div class="flex justify-content-between align-items-start">
											<div class="flex flex-column">
												<div class="text-lg font-semibold flex align-items-center gap-1">
													Emprunt <app-employe-avec-emplacement
														[employe]="historique.emprunt.employe"></app-employe-avec-emplacement>
												</div>
												<div *ngIf="isMobile" class="text-sm text-500 mb-2">
													<ng-container *ngIf="historique.emprunt">
														{{historique.emprunt.dateAffectation | date:'yyyy-MM-dd'}}
													</ng-container>
												</div>
											</div>
											<p-button *ngIf="estAutorise('emprunt') && !modeApercu" icon="pi pi-eye"
												label="Détails" pTooltip="Voir l'emprunt" styleClass="ml-2" text
												size="small"
												[routerLink]="['/emprunt', historique.emprunt.empruntId]"></p-button>
										</div>
										<div *ngIf="!isMobile" class="grid">
											<div class="col-12 md:col-5">
												<div class="flex align-items-center">
													<strong class="mr-2">De:</strong>
													<ng-container *ngIf="historique.emprunt.emplacementDepart">
														<a
															[routerLink]="['/emplacement', historique.emprunt.emplacementDepart.emplacementId]">{{historique.emprunt.emplacementDepart.nom}}
															({{historique.emprunt.emplacementDepart.code}})</a>
													</ng-container>
													<ng-container
														*ngIf="historique.emprunt.employeDepart && !historique.emprunt.emplacementDepart">
														<app-employe-avec-emplacement
															[employe]="historique.emprunt.employeDepart"></app-employe-avec-emplacement>
													</ng-container>
												</div>
											</div>
											<div class="col-12 md:col-1">
												<div class="flex align-items-center justify-content-center">
													<i class="pi pi-arrow-right"></i>
												</div>
											</div>
											<div class="col-12 md:col-5">
												<div class="flex align-items-center">
													<strong class="mr-2">À:</strong>
													<app-employe-avec-emplacement
														[employe]="historique.emprunt.employe"></app-employe-avec-emplacement>
												</div>
											</div>
										</div>
										<div *ngIf="isMobile" class="flex flex-column gap-1 my-1">
											<p-chip *ngIf="historique.emprunt.emplacementDepart"
												label="De: {{historique.emprunt.emplacementDepart.nom}} ({{historique.emprunt.emplacementDepart.code}})"
												[routerLink]="['/emplacement', historique.emprunt.emplacementDepart.emplacementId]"></p-chip>
											<p-chip
												*ngIf="historique.emprunt.employeDepart && !historique.emprunt.emplacementDepart"
												label="De: {{historique.emprunt.employeDepart | nomEmploye}}"></p-chip>
											<p-chip label="À: {{historique.emprunt.employe | nomEmploye}}"></p-chip>
										</div>
										<div class="" *ngIf="historique.emprunt.employeDemandePar">
											<strong>Demandeur:</strong> <app-employe-avec-emplacement
												[employe]="historique.emprunt.employeDemandePar"></app-employe-avec-emplacement>
										</div>
										<div class=""
											*ngIf="historique?.emprunt?.statut?.statutId == EStatuts.Archive && (historique.emprunt.dateRetour || historique.emprunt.dateRetourActuelle)">
											<strong>Retour:</strong> À l'emplacement <a
												[routerLink]="['/emplacement', historique.emprunt.emplacementRetour?.emplacementId]">{{historique.emprunt.emplacementRetour?.nom}}
												({{historique.emprunt.emplacementRetour?.code}})</a> le
											{{historique.emprunt.dateRetour || historique.emprunt.dateRetourActuelle |
											date:'yyyy-MM-dd'}}
										</div>
									</ng-container>
								</p-card>
							</ng-template>
						</p-timeline>
					</div>
					</p-card>
				</p-tabPanel>
				<!-- #endregion -->
				<!-- #region Heures -->
				<p-tabPanel *ngIf="estAutorise('item_heures') && item.value().categorie.estUnique" header="Heures/KM"
					leftIcon="pi pi-clock">
					<p-card>
					<p-menu #menuContextuelReleveHeure popup="popup" [model]="contenuMenuContextuelReleveHeure">
					</p-menu>
					<p-menu #menuContextuelReleveKm popup="popup" [model]="contenuMenuContextuelReleveKm">
					</p-menu>

					<p-card *ngIf="!chargementCompleteRelevesHeure">
						<div class="fluid formgrid grid">
							<div class="flex flex-column gap-2 my-2 col-12 text-center">
								<p-progressSpinner></p-progressSpinner>
							</div>
						</div>
					</p-card>

					<div *ngIf="chargementCompleteRelevesHeure">
						<div class="flex gap-2 flex-wrap">
							<p-card class="flex-grow-1">
								<p-table #dtHeures [value]="item.value().relevesHeure" dataKey="releveHeureId"
									tableStyleClass="tableNormale" autoLayout="true" styleClass="p-datatable-striped"
									[rowHover]="true" [filterDelay]="0" [globalFilterFields]="['date','nbHeure']">
									<ng-template pTemplate="caption">
										<div class="flex align-content-center justify-content-between">
											<div>
												<span class="p-input-icon-left">
													<i class="pi pi-search"></i>
													<input pInputText type="text"
														(input)="dtHeures.filterGlobal($event.target.value, 'contains')"
														placeholder="Recherche..." />
												</span>
												<!-- <button *ngIf="estAutorise('item_heure_creer') && !modeApercu" pButton pRipple
											icon="pi pi-plus"
											class="p-button-rounded p-button-success p-button-sm mb-2 ml-4"
											(click)="ajouterReleveHeure()"></button> -->

											</div>
											<h5 class="titreTableau m-0">Heures</h5>
											<div>
												<p-multiSelect disabled="true" [style]="{minWidth: '200px'}"
													placeholder="Colonnes..."></p-multiSelect>
											</div>
										</div>
									</ng-template>
									<ng-template pTemplate="header">
										<tr>
											<th pSortableColumn="date">
												<div class="flex justify-content-between align-items-center">
													Date
													<p-sortIcon field="date"></p-sortIcon>
													<p-columnFilter type="date" field="date" display="menu"
														class="ml-auto">
													</p-columnFilter>
												</div>
											</th>
											<th pSortableColumn="nbHeure">
												<div class="flex justify-content-between align-items-center">
													Nb Heures
													<p-sortIcon field="nbHeure"></p-sortIcon>
													<p-columnFilter type="numeric" field="nbHeure" display="menu"
														class="ml-auto">
													</p-columnFilter>
												</div>
											</th>
											<th pSortableColumn="employe.nom">
												<div class="flex justify-content-between align-items-center">
													Saisi par
													<p-sortIcon field="employe.nom"></p-sortIcon>
													<p-columnFilter type="text" field="employe.nom" display="menu"
														class="ml-auto">
													</p-columnFilter>
												</div>
											</th>
											<th pSortableColumn="bonTravailNumero">
												<div class="flex justify-content-between align-items-center">
													Bon de travail
													<p-sortIcon field="bonTravailNumero"></p-sortIcon>
													<p-columnFilter type="text" field="bonTravailNumero" display="menu"
														class="ml-auto">
													</p-columnFilter>
												</div>
											</th>
											<th *ngIf="!modeApercu" style="min-width: 5rem; width: 5rem;"></th>
										</tr>
									</ng-template>
									<ng-template pTemplate="body" let-heure>

										<tr>
											<td>{{heure.date | date:'yyyy-MM-dd'}}</td>
											<td>{{heure.nbHeure}}</td>
											<td><app-employe-avec-emplacement
													[employe]="heure.employe"></app-employe-avec-emplacement></td>
											<td>
												@if (heure.bonTravailNumero) {
													<p-tag severity="info" icon="pi pi-link"
														[value]="heure.bonTravailNumero + (heure.indDebut ? ' (début)' : ' (fin)')"></p-tag>
												}
											</td>

											<td *ngIf="!modeApercu">
												<button
													*ngIf="estAutorise('item_heure_modifier') || estAutorise('item_heure_supprimer')"
													pButton pRipple icon="pi pi-bars"
													class="p-button-secondary mr-2 boutonGrille"
													(click)="surMenuContextuelReleveHeure($event, heure)"></button>
											</td>
										</tr>
									</ng-template>
									<ng-template pTemplate="emptymessage">
										<tr>
											<td colspan="5">Aucun relevé d'heures.</td>
										</tr>
									</ng-template>
								</p-table>
							</p-card>
							<p-card class="flex-grow-1">
								<p-table #dtKms [value]="item.value().relevesKm" dataKey="releveKmId" autoLayout="true"
									styleClass="p-datatable-striped" [rowHover]="true" [filterDelay]="0"
									[globalFilterFields]="['date','nbKm']">
									<ng-template pTemplate="caption">
										<div class="flex align-content-center justify-content-between">
											<div>
												<span class="p-input-icon-left">
													<i class="pi pi-search"></i>
													<input pInputText type="text"
														(input)="dtKms.filterGlobal($event.target.value, 'contains')"
														placeholder="Recherche..." />
												</span>
												<!-- <button *ngIf="estAutorise('item_heure_creer') && !modeApercu" pButton pRipple
											icon="pi pi-plus"
											class="p-button-rounded p-button-success p-button-sm mb-2 ml-4"
											(click)="ajouterReleveKm()"></button> -->

											</div>
											<h5 class="titreTableau m-0">Kms</h5>
											<div>
												<p-multiSelect disabled="true" [style]="{minWidth: '200px'}"
													placeholder="Colonnes..."></p-multiSelect>
											</div>
										</div>
									</ng-template>
									<ng-template pTemplate="header">
										<tr>
											<th pSortableColumn="date">
												<div class="flex justify-content-between align-items-center">
													Date
													<p-sortIcon field="date"></p-sortIcon>
													<p-columnFilter type="date" field="date" display="menu"
														class="ml-auto">
													</p-columnFilter>
												</div>
											</th>
											<th pSortableColumn="nbKm">
												<div class="flex justify-content-between align-items-center">
													Nb Km
													<p-sortIcon field="nbKm"></p-sortIcon>
													<p-columnFilter type="numeric" field="nbKm" display="menu"
														class="ml-auto">
													</p-columnFilter>
												</div>
											</th>
											<th pSortableColumn="employe.nom">
												<div class="flex justify-content-between align-items-center">
													Saisi par
													<p-sortIcon field="employe.nom"></p-sortIcon>
													<p-columnFilter type="text" field="employe.nom" display="menu"
														class="ml-auto">
													</p-columnFilter>
												</div>
											</th>
											<th pSortableColumn="bonTravailNumero">
												<div class="flex justify-content-between align-items-center">
													Bon de travail
													<p-sortIcon field="bonTravailNumero"></p-sortIcon>
													<p-columnFilter type="text" field="bonTravailNumero" display="menu"
														class="ml-auto">
													</p-columnFilter>
												</div>
											</th>
											<th *ngIf="!modeApercu" style="min-width: 5rem; width: 5rem;"></th>
										</tr>
									</ng-template>
									<ng-template pTemplate="body" let-km>

										<tr>
											<td>{{km.date | date:'yyyy-MM-dd'}}</td>
											<td>{{km.nbKm}}</td>
											<td><app-employe-avec-emplacement
													[employe]="km.employe"></app-employe-avec-emplacement></td>
											<td>
												@if (km.bonTravailNumero) {
													<p-tag severity="info" icon="pi pi-link"
														[value]="km.bonTravailNumero + (km.indDebut ? ' (début)' : ' (fin)')"></p-tag>
												}
											</td>

											<td *ngIf="!modeApercu">
												<button
													*ngIf="estAutorise('item_heure_modifier') || estAutorise('item_heure_supprimer')"
													pButton pRipple icon="pi pi-bars"
													class="p-button-secondary mr-2 boutonGrille"
													(click)="surMenuContextuelReleveKm($event, km)"></button>
											</td>
										</tr>
									</ng-template>
									<ng-template pTemplate="emptymessage">
										<tr>
											<td colspan="5">Aucun relevé de KM.</td>
										</tr>
									</ng-template>
								</p-table>
							</p-card>
						</div>
					</div>
					</p-card>
				</p-tabPanel>
				<!-- #endregion -->
				<!-- #region Fournisseurs -->
				<p-tabPanel *ngIf="estAutorise('item_fournisseurs') && !item.value().categorie.estUnique"
					[header]="'Fournisseurs (' + item.value().nbEntreesFournisseurs + ')'" leftIcon="pi pi-user">
					<p-card>
					<p-menu #menuContextuelFournisseur popup="popup" [model]="contenuMenuContextuelFournisseur">
					</p-menu>

					<p-card *ngIf="!chargementCompletePrixFournisseurs">
						<div class="fluid formgrid grid">
							<div class="flex flex-column gap-2 my-2 col-12 text-center">
								<p-progressSpinner></p-progressSpinner>
							</div>
						</div>
					</p-card>

					<p-table *ngIf="chargementCompletePrixFournisseurs" #dtFournisseurs
						[value]="item.value().fournisseurs" tableStyleClass="tableNormale" autoLayout="true"
						dataKey="id"
						[globalFilterFields]="['fournisseur.nom','prix','fournisseur.numero','numeroFournisseur']">
						<ng-template pTemplate="caption">
							<div class="flex p-flex-column p-flex-md-row p-jc-md-between table-header">
								<div>
									<span class="p-input-icon-left">
										<i class="pi pi-search"></i>
										<input pInputText type="text"
											(input)="dtFournisseurs.filterGlobal($event.target.value, 'contains')"
											placeholder="Recherche..." />

									</span>
									<button *ngIf="estAutorise('temp_mec') || estAutorise('bdc_creer')" pButton pRipple
										icon="pi pi-plus" class="p-button-success mr-2 ml-4 mb-2 boutonGrille"
										(click)="AjouterFournisseur()"></button>
								</div>
								<div></div>
								<div></div>

							</div>
						</ng-template>
						<ng-template pTemplate="header">
							<tr>
								<th pSortableColumn="numero">
									<div class="flex justify-content-between align-items-center">
										Numéro
										<p-sortIcon field="numero"></p-sortIcon>
										<p-columnFilter type="text" field="numero" display="menu" class="ml-auto">
										</p-columnFilter>
									</div>
								</th>
								<th pSortableColumn="Nom">
									<div class="flex justify-content-between align-items-center">
										Nom
										<p-sortIcon field="Nom"></p-sortIcon>
										<p-columnFilter type="text" field="Nom" display="menu" class="ml-auto">
										</p-columnFilter>
									</div>
								</th>
								<th>
									<div class="flex justify-content-between align-items-center">
										Statut
									</div>
								</th>
								<th pSortableColumn="numeroFournisseur">
									<div class="flex justify-content-between align-items-center">
										No pièce fournisseur
										<p-sortIcon field="numeroFournisseur"></p-sortIcon>
										<p-columnFilter type="text" field="numeroFournisseur" display="menu"
											class="ml-auto">
										</p-columnFilter>
									</div>
								</th>
								<th pSortableColumn="prix">
									<div class="flex justify-content-between align-items-center">
										Prix
										<p-sortIcon field="prix"></p-sortIcon>
										<p-columnFilter type="text" field="prix" display="menu" class="ml-auto">
										</p-columnFilter>
									</div>
								</th>
								<th pSortableColumn="dateDebut">
									<div class="flex justify-content-between align-items-center">
										Date de début
										<p-sortIcon field="dateDebut"></p-sortIcon>
										<p-columnFilter type="dateDebut" field="date" display="menu" class="ml-auto">
										</p-columnFilter>
									</div>
								</th>
								<th pSortableColumn="dateFin">
									<div class="flex justify-content-between align-items-center">
										Date de fin
										<p-sortIcon field="dateFin"></p-sortIcon>
										<p-columnFilter type="dateFin" field="date" display="menu" class="ml-auto">
										</p-columnFilter>
									</div>
								</th>
								<th pSortableColumn="fournisseur.contactPrincipal.prenom">
									<div class="flex justify-content-between align-items-center">
										Contact principal
										<p-sortIcon field="fournisseur.contactPrincipal.prenom"></p-sortIcon>
										<p-columnFilter type="text" field="fournisseur.contactPrincipal.prenom"
											display="menu" class="ml-auto">
										</p-columnFilter>
									</div>
								</th>
								<th pSortableColumn="fournisseur.contactPrincipal.courriel">
									<div class="flex justify-content-between align-items-center">
										Courriel
										<p-sortIcon field="fournisseur.contactPrincipal.courriel"></p-sortIcon>
										<p-columnFilter type="text" field="fournisseur.contactPrincipal.courriel"
											display="menu" class="ml-auto">
										</p-columnFilter>
									</div>
								</th>
								<th pSortableColumn="fournisseur.contactPrincipal.telephone">
									<div class="flex justify-content-between align-items-center">
										Téléphone
										<p-sortIcon field="fournisseur.contactPrincipal.telephone"></p-sortIcon>
										<p-columnFilter type="text" field="fournisseur.contactPrincipal.telephone"
											display="menu" class="ml-auto">
										</p-columnFilter>
									</div>
								</th>
								<th pSortableColumn="fournisseur.contactPrincipal.cellulaire">
									<div class="flex justify-content-between align-items-center">
										Cellulaire
										<p-sortIcon field="fournisseur.contactPrincipal.cellulaire"></p-sortIcon>
										<p-columnFilter type="text" field="fournisseur.contactPrincipal.cellulaire"
											display="menu" class="ml-auto">
										</p-columnFilter>
									</div>
								</th>
								<th *ngIf="!modeApercu" style="min-width: 5rem;"></th>
							</tr>
						</ng-template>
						<ng-template pTemplate="body" let-prixFournisseur>
							<tr [pContextMenuRow]="prixFournisseur">
								<td>
									<div class="flex align-items-center justify-content-between gap-1">
										<div>{{prixFournisseur.fournisseur.numero}}</div>
										<p-tag
											[severity]="fournisseurService.getQualityScore(prixFournisseur.fournisseur)"
											[value]="fournisseurService.getQualityScoreLabel(prixFournisseur.fournisseur)">
										</p-tag>
									</div>
								</td>
								<td>
									{{prixFournisseur.fournisseur.nom}}
								</td>
								<td>
									<span *ngIf="!prixFournisseur.dateFin || prixFournisseur.dateFin > dateJour"
										class="statut actif">
										Actif
									</span>
									<span
										*ngIf="prixFournisseur.dateDebut > dateJour || (prixFournisseur.dateFin && prixFournisseur.dateFin < dateJour)"
										class="statut inactif">
										Inactif
									</span>
								</td>
								<td>
									{{prixFournisseur.numeroFournisseur}}
								</td>
								<td>
									{{prixFournisseur.prix | currency}}
								</td>
								<td>
									{{prixFournisseur.dateDebut | date:'yyyy-MM-dd'}}
								</td>
								<td>
									{{prixFournisseur.dateFin | date:'yyyy-MM-dd'}}
								</td>
								<td>{{prixFournisseur.fournisseur.contactPrincipal?.prenom}}
									{{prixFournisseur.fournisseur.contactPrincipal?.nom}}</td>
								<td>{{prixFournisseur.fournisseur.contactPrincipal?.courriel}}</td>
								<td>{{prixFournisseur.fournisseur.contactPrincipal?.telephone}}</td>
								<td>{{prixFournisseur.fournisseur.contactPrincipal?.cellulaire}}</td>
								<td *ngIf="!modeApercu">
									<button *ngIf="estAutorise('fournisseur_detail') || estAutorise('bdc_creer')"
										pButton pRipple icon="pi pi-bars" class="p-button-secondary mr-2 boutonGrille"
										(click)="surMenuContextuelFournisseur($event, prixFournisseur)"></button>
								</td>
							</tr>
						</ng-template>
						<ng-template pTemplate="emptymessage">
							<tr>
								<td colspan="11">Aucun fournisseur.</td>
							</tr>
						</ng-template>
					</p-table>
					</p-card>
				</p-tabPanel>
				<!-- #endregion -->
				<!-- #region Achats -->
				<p-tabPanel *ngIf="estAutorise('item_achats') && !item.value().categorie.estUnique"
					[header]="'Achats (' + item.value().nbEntreesAchats + ')'" leftIcon="pi pi-shopping-cart">

					<p-card>
					<p-menu #menuContextuelAchat popup="popup" [model]="contenuMenuContextuelAchat"></p-menu>

					<p-card *ngIf="!chargementCompleteAchats">
						<div class="fluid formgrid grid">
							<div class="flex flex-column gap-2 my-2 col-12 text-center">
								<p-progressSpinner></p-progressSpinner>
							</div>
						</div>
					</p-card>

					<p-table *ngIf="chargementCompleteAchats" #dtAchats [value]="item.value().achats" autoLayout="true"
						tableStyleClass="tableNormale" dataKey="itemBonCommandeId"
						[globalFilterFields]="['noFournisseur','prix','bonCommande.numero','bonCommande.dateAchat','bonCommande.fournisseur.numero','bonCommande.fournisseur.nom']">
						<ng-template pTemplate="caption">
							<div class="flex p-flex-column p-flex-md-row p-jc-md-between table-header">
								<span class="p-input-icon-left">
									<i class="pi pi-search"></i>
									<input pInputText type="text"
										(input)="dtAchats.filterGlobal($event.target.value, 'contains')"
										placeholder="Recherche..." />
									<button pButton pRipple label="Analyser les achats" icon="pi pi-chart-line"
										class="p-button-text" (click)="analyserItem()"></button>
								</span>
							</div>
						</ng-template>
						<ng-template pTemplate="header">
							<tr>
								<th pSortableColumn="bonCommande.numero">
									<div class="flex justify-content-between align-items-center">
										No BDC
										<p-sortIcon field="bonCommande.numero"></p-sortIcon>
										<p-columnFilter type="text" field="bonCommande.numero" display="menu"
											class="ml-auto">
										</p-columnFilter>
									</div>
								</th>
								<th pSortableColumn="bonCommande.dateAchat">
									<div class="flex justify-content-between align-items-center">
										Date
										<p-sortIcon field="bonCommande.dateAchat"></p-sortIcon>
										<p-columnFilter type="date" field="bonCommande.dateAchat" display="menu"
											class="ml-auto">
										</p-columnFilter>
									</div>
								</th>
								<th>
									<div class="flex justify-content-between align-items-center">
										Statut
									</div>
								</th>

								<!-- <th pSortableColumn="numeroFournisseur">
									<div class="flex justify-content-between align-items-center">
										No pièce fournisseur
										<p-sortIcon field="numeroFournisseur"></p-sortIcon>
										<p-columnFilter type="text" field="numeroFournisseur" display="menu"
											class="ml-auto">
										</p-columnFilter>
									</div>
								</th> -->
								<th pSortableColumn="bonCommande.fournisseur.nom">
									<div class="flex justify-content-between align-items-center">
										Fournisseur
										<p-sortIcon field="bonCommande.fournisseur.nom"></p-sortIcon>
										<p-columnFilter type="text" field="bonCommande.fournisseur.nom" display="menu"
											class="ml-auto">
										</p-columnFilter>
									</div>
								</th>
								<th pSortableColumn="quantite">
									<div class="flex justify-content-between align-items-center">
										Quantité
										<p-sortIcon field="quantite"></p-sortIcon>
										<p-columnFilter type="number" field="quantite" display="menu" class="ml-auto">
										</p-columnFilter>
									</div>
								</th>
								<th pSortableColumn="prix">
									<div class="flex justify-content-between align-items-center">
										Prix
										<p-sortIcon field="prix"></p-sortIcon>
										<p-columnFilter type="text" field="prix" display="menu" class="ml-auto">
										</p-columnFilter>
									</div>
								</th>
								<th *ngIf="!modeApercu" style="min-width: 5rem;"></th>
							</tr>
						</ng-template>
						<ng-template pTemplate="body" let-achat>
							<tr [pContextMenuRow]="achat">
								<td>
									{{achat.bonCommande.numero}}
								</td>
								<td>
									{{achat.bonCommande.dateAchat | date:'yyyy-MM-dd'}}
								</td>
								<td>
									<span
										[class]="'statut ' + achat.bonCommande.statut.nom.toLowerCase().replace(' ','')">
										{{achat.bonCommande.statut.nom}}
									</span>
								</td>
								<!-- <td>
									{{achat.bonCommande.fournisseur.numero}}
								</td> -->
								<td>
									{{achat.bonCommande.fournisseur.nom}} ({{achat.bonCommande.fournisseur.numero}})
								</td>
								<td>
									{{achat.quantite}}
								</td>
								<td>
									{{achat.prix | currency}}
								</td>
								<td *ngIf="!modeApercu">
									<button
										*ngIf="estAutorise('bdc_detail') || estAutorise('fournisseur_detail') || estAutorise('bdc_creer')"
										pButton pRipple icon="pi pi-bars" class="p-button-secondary mr-2 boutonGrille"
										(click)="surMenuContextuelAchat($event, achat)"></button>
									<button *ngIf="estAutorise('bdc_detail')" pButton pRipple icon="pi pi-external-link"
										class="p-button-secondary mr-2 boutonGrille"
										(click)="OuvrirDetailBdcNouvelOnglet(achat.bonCommandeId)"></button>
								</td>
							</tr>
						</ng-template>
						<ng-template pTemplate="emptymessage">
							<tr>
								<td colspan="7">Aucun achat.</td>
							</tr>
						</ng-template>
					</p-table>
					</p-card>
				</p-tabPanel>
				<!-- #endregion -->
				<!-- #region Soumissions -->
				<p-tabPanel *ngIf="estAutorise('item_soumissions') && !item.value().categorie.estUnique"
					[header]="'Soumissions (' + item.value().nbEntreesSoumissions + ')'" leftIcon="pi pi-dollar">
					<p-card>
					<p-menu #menuContextuelSoumissions popup="popup" [model]="contenuMenuContextuelSoumissions">
					</p-menu>

					<p-card *ngIf="!chargementCompleteSoumissions">
						<div class="fluid formgrid grid">
							<div class="flex flex-column gap-2 my-2 col-12 text-center">
								<p-progressSpinner></p-progressSpinner>
							</div>
						</div>
					</p-card>

					<p-table *ngIf="chargementCompleteSoumissions" #dtSoumissions [value]="item.value().soumissions"
						[columns]="selectedColumns" dataKey="soumissionId" autoLayout="true"
						tableStyleClass="tableNormale" [(contextMenuSelection)]="selectionSoumission" [rowHover]="true"
						[rows]="25" [paginator]="true" [filterDelay]="0"
						[globalFilterFields]="['numero','date','fournisseur.nom','fournisseur.numero']">
						<ng-template pTemplate="caption">
							<div class="flex align-content-center justify-content-between">
								<div>
									<span class="p-input-icon-left">
										<i class="pi pi-search"></i>
										<input pInputText type="text"
											(input)="dtSoumissions.filterGlobal($event.target.value, 'contains')"
											placeholder="Recherche..." />
									</span>
									<button *ngIf="!modeApercu" pButton pRipple icon="pi pi-plus"
										class="p-button-rounded p-button-success p-button-sm mb-2 ml-4"
										(click)="ajouterSoumission()"></button>
								</div>
								<h5 class="titreTableau m-0">Soumissions</h5>
								<div>
									<p-multiSelect [options]="cols" [(ngModel)]="selectedColumns" optionLabel="header"
										selectedItemsLabel="{0} colonnes sélectionnés" [style]="{minWidth: '200px'}"
										placeholder="Colonnes..."></p-multiSelect>
								</div>
							</div>
						</ng-template>

						<ng-template pTemplate="header" let-columns>
							<tr>
								<th pSortableColumn="fournisseur.nom">
									<div class="flex justify-content-between align-items-center">
										Fournisseur
										<p-sortIcon field="fournisseur.nom"></p-sortIcon>
										<p-columnFilter type="text" field="fournisseur.nom" display="menu"
											class="ml-auto">
										</p-columnFilter>
									</div>
								</th>
								<th pSortableColumn="statut.nom">
									<div class="flex justify-content-between align-items-center">
										Statut
										<p-sortIcon field="statut.nom"></p-sortIcon>
										<p-columnFilter type="text" field="statut.nom" display="menu" class="ml-auto">
										</p-columnFilter>
									</div>
								</th>
								<th pSortableColumn="dateDebut">
									<div class="flex justify-content-between align-items-center">
										Date de début
										<p-sortIcon field="dateDebut"></p-sortIcon>
										<p-columnFilter type="text" field="dateDebut" display="menu" class="ml-auto">
										</p-columnFilter>
									</div>
								</th>
								<th pSortableColumn="dateFin">
									<div class="flex justify-content-between align-items-center">
										Date de fin
										<p-sortIcon field="dateFin"></p-sortIcon>
										<p-columnFilter type="date" field="dateFin" display="menu" class="ml-auto">
										</p-columnFilter>
									</div>
								</th>
								<th pSortableColumn="dateDebutSaisie">
									<div class="flex justify-content-between align-items-center">
										Date début saisie
										<p-sortIcon field="dateDebutSaisie"></p-sortIcon>
										<p-columnFilter type="date" field="dateDebutSaisie" display="menu"
											class="ml-auto">
										</p-columnFilter>
									</div>
								</th>
								<th pSortableColumn="dateFinSaisie">
									<div class="flex justify-content-between align-items-center">
										Date Fin Saisie
										<p-sortIcon field="dateFinSaisie"></p-sortIcon>
										<p-columnFilter type="date" field="dateFinSaisie" display="menu"
											class="ml-auto">
										</p-columnFilter>
									</div>
								</th>

								<th *ngIf="!modeApercu" style="min-width: 7rem; width: 7rem;"></th>
							</tr>
						</ng-template>
						<ng-template pTemplate="body" let-soumission let-columns="columns">
							<tr>

								<td>{{soumission.fournisseur.nom}}</td>
								<td><span [class]="'statut ' + soumission.statut.nom.toLowerCase().replace(' ', '')">
										{{soumission.statut.nom}}
									</span></td>
								<td>{{soumission.dateDebut | date:'yyyy-MM-dd'}}</td>
								<td>{{soumission.dateFin | date:'yyyy-MM-dd'}}</td>
								<td>{{soumission.dateDebutSaisie | date:'yyyy-MM-dd'}}</td>
								<td>{{soumission.dateFinSaisie | date:'yyyy-MM-dd'}}</td>

								<td *ngIf="!modeApercu" class="celluleTableau flex">
									<button
										*ngIf="estAutorise('soumission_detail') || estAutorise('fournisseur_detail')"
										pButton pRipple icon="pi pi-bars" class="p-button-secondary mr-2 boutonGrille"
										(click)="surMenuContextuelSoumission($event, soumission)"></button>
								</td>
							</tr>
						</ng-template>
						<ng-template pTemplate="emptymessage">
							<tr>
								<td colspan="7">Aucune soumission.</td>
							</tr>
						</ng-template>
					</p-table>

					</p-card>
				</p-tabPanel>
				<!-- #endregion -->
				<!-- #region Associations -->
				<p-tabPanel
					*ngIf="(estAutorise('temp_mec') || estAutorise('item_detail')) && item.value().categorie.categorieId == 6"
					[header]="'Associations (' + item.value().nbEntreesAssociations + ')'" leftIcon="pi pi-user">
					<p-card>
					<p-menu #menuContextuelAssociation popup="popup" [model]="contenuMenuContextuelAssociation">
					</p-menu>

					<p-card *ngIf="!chargementCompleteAssociations">
						<div class="fluid formgrid grid">
							<div class="flex flex-column gap-2 my-2 col-12 text-center">
								<p-progressSpinner></p-progressSpinner>
							</div>
						</div>
					</p-card>

					<p-table *ngIf="chargementCompleteAssociations" #dtAssoc [value]="item.value().associations"
						[columns]="selectedColumns" dataKey="pieceUniteId" autoLayout="true"
						tableStyleClass="tableNormale" [rowHover]="true" [filterDelay]="0"
						[globalFilterFields]="['piece.numero','piece.description','piece.modele','piece.marque','categorieEntretien.code','categorieEntretien.description']">
						<ng-template pTemplate="caption">
							<div class="flex align-content-center justify-content-between">
								<div>
									<span class="p-input-icon-left">
										<i class="pi pi-search"></i>
										<input #rechercheItem pInputText type="text"
											(input)="dtAssoc.filterGlobal($event.target.value, 'contains')"
											placeholder="Recherche..." />
									</span>
									<button *ngIf="estAutorise('piece_associer')" pButton pRipple icon="pi pi-plus"
										class="p-button-success mr-2 ml-4 mb-2 boutonGrille"
										(click)="ajouterAssociation()"></button>
								</div>
								<div>
									<h5 class="titreTableau m-0">Associations</h5>
								</div>

								<div>
									<p-multiSelect disabled="true" [style]="{minWidth: '200px'}"
										placeholder="Colonnes..."></p-multiSelect>
								</div>
							</div>
						</ng-template>
						<ng-template pTemplate="header" let-columns>
							<tr>
								<th pSortableColumn="categorieEntretien.code">
									<div class="flex justify-content-between align-items-center">
										Catégorie
										<p-sortIcon field="categorieEntretien.code"></p-sortIcon>
										<p-columnFilter type="text" field="categorieEntretien.code" display="menu"
											class="ml-auto">
										</p-columnFilter>
									</div>
								</th>
								<th pSortableColumn="unite.numero">
									<div class="flex justify-content-between align-items-center">
										Numéro
										<p-sortIcon field="unite.numero"></p-sortIcon>
										<p-columnFilter type="text" field="unite.numero" display="menu" class="ml-auto">
										</p-columnFilter>
									</div>
								</th>
								<th pSortableColumn="unite.description">
									<div class="flex justify-content-between align-items-center">
										Description
										<p-sortIcon field="unite.description"></p-sortIcon>
										<p-columnFilter type="text" field="unite.description" display="menu"
											class="ml-auto">
										</p-columnFilter>
									</div>
								</th>
								<th pSortableColumn="unite.marque">
									<div class="flex justify-content-between align-items-center">
										Marque
										<p-sortIcon field="unite.marque"></p-sortIcon>
										<p-columnFilter type="text" field="unite.marque" display="menu" class="ml-auto">
										</p-columnFilter>
									</div>
								</th>
								<th pSortableColumn="unite.modele">
									<div class="flex justify-content-between align-items-center">
										Modèle
										<p-sortIcon field="unite.modele"></p-sortIcon>
										<p-columnFilter type="text" field="unite.modele" display="menu" class="ml-auto">
										</p-columnFilter>
									</div>
								</th>
								<th pSortableColumn="note">
									<div class="flex justify-content-between align-items-center">
										Note
										<p-sortIcon field="note"></p-sortIcon>
										<p-columnFilter type="text" field="note" display="menu" class="ml-auto">
										</p-columnFilter>
									</div>
								</th>
								<th style="min-width: 7rem; width: 7rem;"></th>

							</tr>


						</ng-template>
						<ng-template pTemplate="body" let-piece let-columns="columns">
							<tr>
								<td>{{piece.categorieEntretien?.code}} - {{piece.categorieEntretien?.description}}</td>
								<td>{{piece.unite.numero}}</td>
								<td>{{piece.unite.description}}</td>
								<td>{{piece.unite.marque}}</td>
								<td>{{piece.unite.modele}}</td>
								<td>{{piece.note}}</td>
								<td class="celluleTableau">
									<div class="flex">
										<button pButton pRipple icon="pi pi-bars"
											class="p-button-secondary mr-2 boutonGrille"
											(click)="surMenuContextuelAssociation($event, piece)"></button>
									</div>
								</td>

							</tr>
						</ng-template>
						<ng-template pTemplate="emptymessage">
							<tr>
								<td colspan="8">Aucune association.</td>
							</tr>
						</ng-template>
					</p-table>

					</p-card>
				</p-tabPanel>
				<!-- #endregion -->
				<!-- #region Documents -->
				<p-tabPanel *ngIf="estAutorise('item_documents')"
					header="Documents ({{chargementCompleteDocuments ? documentsComplet.length : '...'}}) "
					leftIcon="pi pi-file-pdf">
					<ng-template pTemplate="content">
					<p-card>
						<app-document [typeLienDocument]="ETypeLienDocument.Item" [idLien]="item.value().itemId"
							[numero]="item.value().numero"></app-document>
					</p-card>
					</ng-template>
				</p-tabPanel>
				<!-- #endregion -->
				<!-- #region Documents liés -->
				<p-tabPanel *ngIf="estAutorise('item_documents_lies') && item.value().categorie.estUnique"
					header="Documents liés" leftIcon="pi pi-file-pdf">
					<p-card>
					<p-menu #menuContextuelDocumentLie popup="popup" [model]="contenuMenuContextuelDocumentLie">
					</p-menu>

					<p-card *ngIf="!chargementCompleteDocumentsLies">
						<div class="fluid formgrid grid">
							<div class="flex flex-column gap-2 my-2 col-12 text-center">
								<p-progressSpinner></p-progressSpinner>
							</div>
						</div>
					</p-card>

					<div *ngIf="chargementCompleteDocumentsLies">
						<p-table #dtDocumentsLies [value]="item.documentslies" dataKey="documentLieId"
							tableStyleClass="tableNormale" autoLayout="true" styleClass="p-datatable-striped"
							[rowHover]="true" [filterDelay]="0" [globalFilterFields]="['type.nom','date','nom']">
							<ng-template pTemplate="caption">
								<div class="flex align-content-center justify-content-between">
									<div>
										<span class="p-input-icon-left">
											<i class="pi pi-search"></i>
											<input pInputText type="text"
												(input)="dtDocumentsLies.filterGlobal($event.target.value, 'contains')"
												placeholder="Recherche..." />
										</span>

									</div>
									<h5 class="titreTableau m-0">Documents liés</h5>
									<div>
										<p-multiSelect disabled="true" [style]="{minWidth: '200px'}"
											placeholder="Colonnes..."></p-multiSelect>
									</div>
								</div>
							</ng-template>
							<ng-template pTemplate="header">
								<tr>
									<th pSortableColumn="typeDocumentLie.nom">
										<div class="flex justify-content-between align-items-center">
											Type
											<p-sortIcon field="typeDocumentLie.nom"></p-sortIcon>
											<p-columnFilter type="text" field="typeDocumentLie.nom" display="menu"
												class="ml-auto">
											</p-columnFilter>
										</div>
									</th>
									<th pSortableColumn="date">
										<div class="flex justify-content-between align-items-center">
											Date
											<p-sortIcon field="date"></p-sortIcon>
											<p-columnFilter type="date" field="date" display="menu" class="ml-auto">
											</p-columnFilter>
										</div>
									</th>
									<th pSortableColumn="numero">
										<div class="flex justify-content-between align-items-center">
											Numéro
											<p-sortIcon field="numero"></p-sortIcon>
											<p-columnFilter type="text" field="numero" display="menu" class="ml-auto">
											</p-columnFilter>
										</div>
									</th>
									<th pSortableColumn="nom">
										<div class="flex justify-content-between align-items-center">
											Nom
											<p-sortIcon field="nom"></p-sortIcon>
											<p-columnFilter type="text" field="nom" display="menu" class="ml-auto">
											</p-columnFilter>
										</div>
									</th>
									<th *ngIf="!modeApercu" style="min-width: 5rem"></th>
								</tr>
							</ng-template>
							<ng-template pTemplate="body" let-doc>

								<tr>
									<td>{{doc.typeDocumentLie.nom}}</td>
									<td>{{doc.date | date:'yyyy-MM-dd'}}</td>
									<td>{{doc.numero}}</td>
									<td>{{doc.nom}}</td>
									<td *ngIf="!modeApercu">
										<button
											*ngIf="estAutorise('item_document_lie_modifier') || estAutorise('item_document_lie_supprimer')"
											pButton pRipple icon="pi pi-bars"
											class="p-button-secondary mr-2 boutonGrille"
											(click)="surMenuContextuelDocumentLie($event, garantie)"></button>
									</td>
								</tr>
							</ng-template>
							<ng-template pTemplate="emptymessage">
								<tr>
									<td colspan="4">Aucun document lié.</td>
								</tr>
							</ng-template>
						</p-table>
					</div>
					</p-card>
				</p-tabPanel>
				<!-- #endregion -->
				<!-- #region Liaisons -->
				<p-tabPanel *ngIf="estAutorise('item_liaisons') && item.value().categorie.estUnique"
					[header]="'Liaisons (' + item.value().nbEntreesLiaisons + ')'" leftIcon="pi pi-sitemap">
					<p-card>
					<p-menu #menuContextuelLiaison popup="popup" [model]="contenuMenuContextuelLiaison"></p-menu>
					<p-contextMenu #cmLiaison [model]="contenuMenuContextuelLiaison"></p-contextMenu>

					<p-card *ngIf="!chargementCompleteLiaisons">
						<div class="fluid formgrid grid">
							<div class="flex flex-column gap-2 my-2 col-12 text-center">
								<p-progressSpinner></p-progressSpinner>
							</div>
						</div>
					</p-card>

					<div *ngIf="chargementCompleteLiaisons">
						<!-- Header with actions -->
						<div class="flex align-content-center justify-content-between mb-4">
							<div>
								<p-button *ngIf="estAutorise('item_liaison_creer') && !modeApercu" pRipple
									icon="pi pi-plus" severity="success" size="small" label="Ajouter une liaison"
									(click)="ajouterLiaison()" pTooltip="Ajouter une liaison"></p-button>
							</div>
						</div>

						<!-- Organization Chart -->
						<div *ngIf="item.value().liaisons && item.value().liaisons.length > 0">
							<p-organizationChart [value]="liaisonsOrgChart">
								<ng-template let-node pTemplate="default">
									<div class="flex flex-column align-items-center">
										<div class="flex align-items-center gap-1 p-3 border-round-md" [ngClass]="{
												'text-primary-contrast': node.data.icon === 'pi pi-user' || node.data.icon === 'pi pi-map-marker',
												'text-blue-500': node.data.icon === 'pi pi-box',
												'text-green-500': node.data.icon === 'pi pi-link',
												'text-green-500': node.data.showDataView
											}">
											<i [class]="node.data.icon + ' mr-2 text-lg'"></i>
											<div class="flex flex-column">
												<span class="font-semibold">{{node.data.name}}</span>
												<span class="text-sm">{{node.data.title}}</span>
											</div>
											<div *ngIf="node.data.liaison && !modeApercu" class="ml-auto">
												<button pButton pRipple icon="pi pi-bars"
													class="p-button-secondary p-button-sm"
													(click)="surMenuContextuelLiaison($event, node.data.liaison)"
													pTooltip="Actions"></button>
											</div>
										</div>

										<!-- DataView for multiple liaisons -->
										<div *ngIf="node.data.showDataView" class="mt-2 w-full">
											<p-dataView [value]="node.data.liaisons" layout="list">
												<ng-template let-liaison pTemplate="list">
													@for (liaison of node.data.liaisons; track liaison.itemId) {
													<div
														class="flex align-items-center gap-1 p-2 border-bottom-1 surface-border">
														<i class="pi pi-link mr-2 text-green-600"></i>
														<div class="flex-1">
															<div class="font-semibold">{{liaison.numero}}</div>
															<div class="text-sm text-600">{{liaison.description}}</div>
														</div>
														<div *ngIf="!modeApercu">
															<button pButton pRipple icon="pi pi-bars"
																class="p-button-secondary p-button-sm"
																(click)="surMenuContextuelLiaison($event, liaison)"
																pTooltip="Actions"></button>
														</div>
													</div>
													}
												</ng-template>
											</p-dataView>
										</div>
									</div>
								</ng-template>
							</p-organizationChart>
						</div>

						<!-- Empty state -->
						<div *ngIf="!item.value().liaisons || item.value().liaisons.length === 0"
							class="text-center p-4">
							<i class="pi pi-sitemap text-4xl text-400 mb-3"></i>
							<p class="text-600 text-lg">Aucune liaison directe trouvée pour cet item.</p>
							<p class="text-500 text-sm">Les liaisons représentent les relations directes entre les items
								du système.</p>
						</div>
					</div>
					</p-card>
				</p-tabPanel>
				<!-- #endregion -->
				<!-- #region Garanties -->
				<p-tabPanel *ngIf="estAutorise('item_garanties') && item.value().categorie.estUnique"
					[header]="'Garanties (' + item.value().nbEntreesGaranties + ')'" leftIcon="pi pi-shield">
					<p-card>
					<p-menu #menuContextuelGarantie popup="popup" [model]="contenuMenuContextuelGarantie"></p-menu>

					<p-card *ngIf="!chargementCompleteGaranties">
						<div class="fluid formgrid grid">
							<div class="flex flex-column gap-2 my-2 col-12 text-center">
								<p-progressSpinner></p-progressSpinner>
							</div>
						</div>
					</p-card>

					<div *ngIf="chargementCompleteGaranties">
						<p-table #dtGaranties [value]="item.value().garanties" dataKey="garantieId"
							tableStyleClass="tableNormale" autoLayout="true" styleClass="p-datatable-striped"
							[rowHover]="true" [filterDelay]="0"
							[globalFilterFields]="['type.nom','dateDebut','dateFin','description']">
							<ng-template pTemplate="caption">
								<div class="flex align-content-center justify-content-between">
									<div>
										<span class="p-input-icon-left">
											<i class="pi pi-search"></i>
											<input pInputText type="text"
												(input)="dtGaranties.filterGlobal($event.target.value, 'contains')"
												placeholder="Recherche..." />
										</span>
										<button *ngIf="estAutorise('item_garantie_creer') && !modeApercu" pButton
											pRipple icon="pi pi-plus"
											class="p-button-rounded p-button-success p-button-sm mb-2 ml-4"
											(click)="ajouterGarantie()"></button>

									</div>
									<h5 class="titreTableau m-0">Garanties</h5>
									<div>
										<p-multiSelect disabled="true" [style]="{minWidth: '200px'}"
											placeholder="Colonnes..."></p-multiSelect>
									</div>
								</div>
							</ng-template>
							<ng-template pTemplate="header">
								<tr>
									<th pSortableColumn="type.nom">
										<div class="flex justify-content-between align-items-center">
											Type
											<p-sortIcon field="type.nom"></p-sortIcon>
											<p-columnFilter type="text" field="type.nom" display="menu" class="ml-auto">
											</p-columnFilter>
										</div>
									</th>

									<th pSortableColumn="statut.nom">
										<div class="flex justify-content-between align-items-center">
											Statut
											<p-sortIcon field="statut.nom"></p-sortIcon>
											<p-columnFilter field="statut" matchMode="in" display="menu"
												[showMatchModes]="false" [showOperator]="false" [showAddButton]="false">
												<ng-template pTemplate="filter" let-value let-filter="filterCallback">
													<p-multiSelect [ngModel]="value" [options]="statuts"
														placeholder="Any" (onChange)="filter($event.value)"
														optionLabel="name">
														<ng-template let-option pTemplate="item">
															<div class="multiselect-representative-option">

																<span class="ml-1">{{option.nom}}</span>
															</div>
														</ng-template>
													</p-multiSelect>
												</ng-template>
											</p-columnFilter>
										</div>
									</th>
									<th pSortableColumn="dateDebut">
										<div class="flex justify-content-between align-items-center">
											Date de début
											<p-sortIcon field="dateDebut"></p-sortIcon>
											<p-columnFilter type="date" field="dateDebut" display="menu"
												class="ml-auto">
											</p-columnFilter>
										</div>
									</th>
									<th pSortableColumn="dateFin">
										<div class="flex justify-content-between align-items-center">
											Date de fin
											<p-sortIcon field="dateFin"></p-sortIcon>
											<p-columnFilter type="date" field="dateFin" display="menu" class="ml-auto">
											</p-columnFilter>
										</div>
									</th>
									<th pSortableColumn="description">
										<div class="flex justify-content-between align-items-center">
											Description
											<p-sortIcon field="description"></p-sortIcon>
											<p-columnFilter type="text" field="description" display="menu"
												class="ml-auto">
											</p-columnFilter>
										</div>
									</th>
									<th *ngIf="!modeApercu" style="min-width: 5rem"></th>
								</tr>
							</ng-template>
							<ng-template pTemplate="body" let-garantie>

								<tr>
									<td>{{garantie.type.nom}}</td>
									<td><span [class]="'statut ' + garantie.statut.nom.replace(' ','').toLowerCase()">
											{{garantie.statut.nom}}
										</span>
									</td>

									<td>{{garantie.dateDebut | date:'yyyy-MM-dd'}}</td>
									<td>{{garantie.dateFin | date:'yyyy-MM-dd'}}</td>
									<td>{{garantie.description}}</td>

									<td *ngIf="!modeApercu">
										<button
											*ngIf="estAutorise('item_garantie_modifier') || estAutorise('item_garantie_supprimer')"
											pButton pRipple icon="pi pi-bars"
											class="p-button-secondary mr-2 boutonGrille"
											(click)="surMenuContextuelGarantie($event, garantie)"></button>
									</td>
								</tr>
							</ng-template>
							<ng-template pTemplate="emptymessage">
								<tr>
									<td colspan="6">Aucune garantie.</td>
								</tr>
							</ng-template>
						</p-table>
					</div>
					</p-card>
				</p-tabPanel>
				<!-- #endregion -->

				<!-- TODO: Vérifier l'IndSuiviMecanique -->

				<!-- #region Mécanique -->
				<p-tabPanel
					*ngIf="(estAutorise('temp_mec') || estAutorise('unite_entretien')) && item.value().categorie.estUnique"
					header="Entretien" leftIcon="pi pi-briefcase">

					<p-card>
					<p-card *ngIf="!chargementCompleteEntretiens">
						<div class="fluid formgrid grid">
							<div class="flex flex-column gap-2 my-2 col-12 text-center">
								<p-progressSpinner></p-progressSpinner>
							</div>
						</div>
					</p-card>

					<div *ngIf="chargementCompleteEntretiens">
						@if (BonsTravailOuverts.length > 0) {
							<p-messages severity="info" [closable]="false" styleClass="mb-3">
								<ng-template pTemplate>
									<div class="flex flex-column md:flex-row justify-content-between align-items-start md:align-items-center gap-2 w-full">
										<div class="ml-2">
											@if (BonsTravailOuverts.length === 1) {
												Cet item possède un bon de travail ouvert ({{ BonsTravailOuverts[0].numero }}).
											} @else {
												Cet item possède {{ BonsTravailOuverts.length }} bons de travail ouverts.
											}
										</div>
										<p-button
											[label]="'Voir le bon de travail ' + BonsTravailOuverts[0].numero"
											icon="pi pi-external-link"
											(onClick)="OuvrirDetailBdt(BonsTravailOuverts[0].bonTravailId)" />
									</div>
								</ng-template>
							</p-messages>
						}

						<div class="fluid formgrid grid">
							<div class="sihc-field flex flex-column gap-2 my-2 col-12 md:col-2">
								<label for="heuresItem">Heures au compteur</label>
								<span class="champConsultation">{{item.value().heuresCompteur | valeurVide}}
									<i class="pi pi-pencil ml-3" style="cursor: pointer;"
										pTooltip="Ajustement de compteur" (click)="ouvrirAjustements()"></i>
									<i class="pi pi-plus ml-3" style="cursor: pointer;" pTooltip="Ajouter des heures"
										(click)="ajouterHeuresApprouvee()"></i>
								</span>
							</div>
							<div class="sihc-field flex flex-column gap-2 my-2 col-12 md:col-2">
								<label for="heuresItem">Heures réelles</label>
								<span class="champConsultation">{{item.value().heuresReelles | valeurVide}}</span>
							</div>
							<div class="sihc-field flex flex-column gap-2 my-2 col-12 md:col-2">
								<label for="heuresItem">KM au compteur</label>
								<span class="champConsultation">{{item.value().kmCompteur | valeurVide}}
									<i class="pi pi-pencil ml-3" style="cursor: pointer;"
										pTooltip="Ajustement de compteur" (click)="ouvrirAjustementsKm()"></i>
									<i class="pi pi-plus ml-3" style="cursor: pointer;" pTooltip="Ajouter des KMs"
										(click)="ajouterKmsApprouvee()"></i>
								</span>
							</div>
							<div class="sihc-field flex flex-column gap-2 my-2 col-12 md:col-2">
								<label for="heuresItem">KM réels</label>
								<span class="champConsultation">{{item.value().kmReel | valeurVide}}</span>
							</div>
							<div class="sihc-field flex flex-column gap-2 my-2 col-12 md:col-6 lg:col-3">
								<label for="emplacement">Assigné à</label>
								<span *ngIf="item.value().employe"
									class="champConsultation flex align-items-center gap-2">
									<i class="pi pi-user"></i>
									<a [routerLink]="['/employe', item.value().employe.employeId]"><app-employe-avec-emplacement
											[employe]="item.value().employe"></app-employe-avec-emplacement></a>
								</span>
								<span *ngIf="item.value().emplacement"
									class="champConsultation flex align-items-center gap-2">
									<i class="pi pi-map-marker"></i>
									<a [routerLink]="['/emplacement', item.value().emplacement.emplacementId]">{{item.value().emplacement
										| nomEmplacement}}</a>
								</span>
							</div>
						</div>

						<div class="fluid formgrid grid">
							<div class="sihc-field flex flex-column gap-2 my-3 col-12">
								<label for="emplacement">Note mécanique</label>
								<span *ngIf="modeConsultation()" class="champConsultation"
									style="white-space: pre-line; font-size: 1.2rem; color: red;">{{item.value().noteMecanique
									|
									valeurVide}}</span>
								<textarea [rows]="5" pInputTextarea *ngIf="!modeConsultation()"
									[(ngModel)]="item.value().noteMecanique"></textarea>
							</div>
						</div>


						<p-tabView [scrollable]="true" #tabViewEntretiens orientation="left"
							[(activeIndex)]="tabIndexEntretiens" (onChange)="surChangementOngletEntretiens($event)">




							<!-- #region Entretiens préventifs -->
							<p-tabPanel *ngIf="estAutorise('unite_preventifs') || estAutorise('temp_mec')"
								header="Préventifs" leftIcon="pi pi-shield">


								<!------------ PRÉVENTIFS ------------>

								<p-card *ngIf="!chargementCompleteEntretiensPreventifs">
									<div class="fluid formgrid grid">
										<div class="flex flex-column gap-2 my-2 col-12 text-center">
											<p-progressSpinner></p-progressSpinner>
										</div>
									</div>
								</p-card>


								<p-menu #menuContextuelEntretiensPreventifs popup="popup"
									[model]="contenuMenuContextuelEntretiensPreventifs"></p-menu>

								<div *ngIf="chargementCompleteEntretiensPreventifs" class="fluid formgrid grid">


									<div class="col-12 mb-3">
										<p-message *ngIf="calculEnCours" style="width: 100%;" severity="warn"
											text="Des calculs sont en cours pour certains des entretiens affichés. Les informations de ces entretiens ne sont donc pas disponibles pour le moment."
											styleClass="mr-2">

											<i class="pi pi-refresh ml-3" (click)="rechercherUnite()"></i>
										</p-message>
									</div>
								</div>


								<p-table *ngIf="chargementCompleteEntretiensPreventifs" #dt
									[value]="item.value().entretiensPreventifs" [columns]="selectedColumns"
									dataKey="entretienPreventifId" autoLayout="true" tableStyleClass="tableNormale"
									[(selection)]="selectionEntretiensPreventifs"
									[rowHover]="true" [filterDelay]="0" [globalFilterFields]="['description']">
									<ng-template pTemplate="caption">
										<div class="flex align-content-center justify-content-between gap-2 flex-wrap">
											<div class="flex align-items-center gap-3 flex-wrap">
												<span class="p-input-icon-left">
													<i class="pi pi-search"></i>
													<input #rechercheItem pInputText type="text"
														(input)="dt.filterGlobal($event.target.value, 'contains')"
														placeholder="Recherche..." />

												</span>
												<button *ngIf="estAutorise('temp_mec')" pButton pRipple
													icon="pi pi-plus" class="p-button-success"
													(click)="AjouterEntretienPreventif()"></button>
												<button *ngIf="estAutorise('temp_mec')" pButton pRipple
													icon="pi pi-check-square" class="p-button-success"
													[disabled]="!selectionEntretiensPreventifs || selectionEntretiensPreventifs.length == 0"
													(click)="assignerEntretiensPreventifs(selectionEntretiensPreventifs)"></button>
												<button *ngIf="estAutorise('temp_mec')" pButton pRipple
													icon="pi pi-bars" class="p-button-secondary"
													(click)="surMenuContextuelEntretiensPreventifs($event)"></button>
											</div>
											<div>
												<h5 class="titreTableau m-0">Entretiens préventifs</h5>
											</div>

											<div>
												<p-multiSelect disabled="true" [style]="{minWidth: '200px'}"
													placeholder="Colonnes..."></p-multiSelect>
											</div>
										</div>
									</ng-template>
									<ng-template pTemplate="header" let-columns>
										<tr>
											<th rowspan="2" style="min-width: 3rem">

											</th>
											<th rowspan="2" pSortableColumn="description">
												<div class="flex justify-content-between align-items-center">
													Description
													<p-sortIcon field="description"></p-sortIcon>
													<p-columnFilter type="text" field="description" display="menu"
														class="ml-auto">
													</p-columnFilter>
												</div>
											</th>
											<th rowspan="2" pSortableColumn="etat">
												<div class="flex justify-content-between align-items-center">
													Statut
													<p-sortIcon field="etat"></p-sortIcon>
												</div>
											</th>
											<th *ngIf="afficherHeures" colspan="3">
												Heures
											</th>
											<th *ngIf="afficherKms" colspan="3">
												KMs
											</th>
											<th *ngIf="afficherMois" colspan="3">
												Mois
											</th>

											<th rowspan="2" pSortableColumn="bonTravail.numero">
												<div class="flex justify-content-between align-items-center">
													No bon de travail
													<p-sortIcon field="bonTravail.numero"></p-sortIcon>
												</div>
											</th>
											<th rowspan="2" style="min-width: 7rem; width: 7rem;"></th>
										</tr>

										<tr>
											<th *ngIf="afficherHeures" pSortableColumn="heureFait">
												<div class="flex justify-content-between align-items-center">
													Fait
													<p-sortIcon field="heuresFait"></p-sortIcon>
													<p-columnFilter type="numeric" field="heureFait" display="menu"
														class="ml-auto">
													</p-columnFilter>
												</div>
											</th>
											<th *ngIf="afficherHeures" pSortableColumn="heureDu">
												<div class="flex justify-content-between align-items-center">
													Dû
													<p-sortIcon field="heuresDu"></p-sortIcon>
													<p-columnFilter type="numeric" field="heureDu" display="menu"
														class="ml-auto">
													</p-columnFilter>
												</div>
											</th>
											<th *ngIf="afficherHeures" pSortableColumn="heureEcart">
												<div class="flex justify-content-between align-items-center">
													Écart
													<p-sortIcon field="heuresEcart"></p-sortIcon>
													<p-columnFilter type="numeric" field="heureEcart" display="menu"
														class="ml-auto">
													</p-columnFilter>
												</div>
											</th>
											<th *ngIf="afficherKms" pSortableColumn="kmFait">
												<div class="flex justify-content-between align-items-center">
													Fait
													<p-sortIcon field="heuresFait"></p-sortIcon>
													<p-columnFilter type="numeric" field="kmFait" display="menu"
														class="ml-auto">
													</p-columnFilter>
												</div>
											</th>
											<th *ngIf="afficherKms" pSortableColumn="heuresDu">
												<div class="flex justify-content-between align-items-center">
													Dû
													<p-sortIcon field="kmDu"></p-sortIcon>
													<p-columnFilter type="numeric" field="kmDu" display="menu"
														class="ml-auto">
													</p-columnFilter>
												</div>
											</th>
											<th *ngIf="afficherKms" pSortableColumn="kmEcart">
												<div class="flex justify-content-between align-items-center">
													Écart
													<p-sortIcon field="heuresEcart"></p-sortIcon>
													<p-columnFilter type="numeric" field="kmEcart" display="menu"
														class="ml-auto">
													</p-columnFilter>
												</div>
											</th>
											<th *ngIf="afficherMois" pSortableColumn="moisFait">
												<div class="flex justify-content-between align-items-center">
													Fait
													<p-sortIcon field="heuresFait"></p-sortIcon>
													<p-columnFilter type="numeric" field="moisFait" display="menu"
														class="ml-auto">
													</p-columnFilter>
												</div>
											</th>
											<th *ngIf="afficherMois" pSortableColumn="moisDu">
												<div class="flex justify-content-between align-items-center">
													Dû
													<p-sortIcon field="heuresDu"></p-sortIcon>
													<p-columnFilter type="numeric" field="moisDu" display="menu"
														class="ml-auto">
													</p-columnFilter>
												</div>
											</th>
											<th *ngIf="afficherMois" pSortableColumn="moisEcart">
												<div class="flex justify-content-between align-items-center">
													Écart
													<p-sortIcon field="heuresEcart"></p-sortIcon>
													<p-columnFilter type="numeric" field="moisEcart" display="menu"
														class="ml-auto">
													</p-columnFilter>
												</div>
											</th>
										</tr>
									</ng-template>
									<ng-template pTemplate="body" let-preventif let-columns="columns">
										<tr *ngIf="!preventif.indCalculEnCours" [pContextMenuRow]="preventif">
											<td>
												<p-tableCheckbox *ngIf="!preventif.bonTravail"
													[value]="preventif"></p-tableCheckbox>
											</td>
											<td>{{preventif.description}}</td>
											<td><span
													[class]="'statut ' + preventif.statut.nom.toLowerCase().replace(' ','')">
													{{preventif.statut.nom}}
												</span>
											</td>
											<td *ngIf="afficherHeures">{{preventif.heureFaitCompteur}}</td>
											<td *ngIf="afficherHeures">{{preventif.heureDuCompteur}}</td>
											<td *ngIf="afficherHeures">{{preventif.heureEcart}}</td>
											<td *ngIf="afficherKms">{{preventif.kmFaitCompteur}}</td>
											<td *ngIf="afficherKms">{{preventif.kmDuCompteur}}</td>
											<td *ngIf="afficherKms">{{preventif.kmEcart}}</td>
											<td *ngIf="afficherMois">{{preventif.moisFait | date:'yyyy-MM-dd' }}</td>
											<td *ngIf="afficherMois">{{preventif.moisDu | date:'yyyy-MM-dd'}}</td>
											<td *ngIf="afficherMois">{{preventif.moisEcart}}</td>
											<td>{{preventif.bonTravail?.numero}}</td>
											<td class="celluleTableau">
												<div class="flex">
													<button pButton pRipple icon="pi pi-bars"
														class="p-button-secondary mr-2 boutonGrille"
														(click)="surMenuContextuelEntretienPreventif($event, preventif)"></button>
												</div>
											</td>
										</tr>
										<tr *ngIf="preventif.indCalculEnCours" [pContextMenuRow]="preventif">
											<td>
											</td>
											<td>{{preventif.description}} (calcul en cours...)</td>
											<td>---</td>
											<td *ngIf="afficherHeures">---</td>
											<td *ngIf="afficherHeures">---</td>
											<td *ngIf="afficherHeures">---</td>
											<td *ngIf="afficherKms">---</td>
											<td *ngIf="afficherKms">---</td>
											<td *ngIf="afficherKms">---</td>
											<td *ngIf="afficherMois">---</td>
											<td *ngIf="afficherMois">---</td>
											<td *ngIf="afficherMois">---</td>
											<td>---</td>
											<td class="celluleTableau">
												<div class="flex">
													<button pButton pRipple icon="pi pi-bars"
														class="p-button-secondary mr-2 boutonGrille"
														(click)="surMenuContextuelEntretienPreventif($event, preventif)"></button>
												</div>
											</td>
										</tr>
									</ng-template>
									<ng-template pTemplate="emptymessage">
										<tr>
											<td colspan="8">Aucun item.</td>
										</tr>
									</ng-template>
								</p-table>

							</p-tabPanel>
							<!-- #endregion -->

							<!-- #region Entretiens correctifs -->
							<p-tabPanel *ngIf="estAutorise('unite_correctifs') || estAutorise('temp_mec')"
								header="Correctifs" leftIcon="pi pi-briefcase">


								<!------------ CORRECTIFS ------------>

								<p-card *ngIf="!chargementCompleteEntretiensCorrectifs">
									<div class="fluid formgrid grid">
										<div class="flex flex-column gap-2 my-2 col-12 text-center">
											<p-progressSpinner></p-progressSpinner>
										</div>
									</div>
								</p-card>


								<p-menu #menuContextuelEntretiensCorrectifs popup="popup"
									[model]="contenuMenuContextuelEntretiensCorrectifs"></p-menu>

								<div *ngIf="chargementCompleteEntretiensCorrectifs" class="fluid formgrid grid">


									<div class="flex flex-column gap-2 my-2 col-12 md:col-3">
										<label for="lastname">Code de catégorie</label>
										<p-dropdown [options]="listeCategoriesEntretien"
											[(ngModel)]="selectionCategorieEntretienCorrectifs" [showClear]="true"
											optionLabel="description" [showClear]="true" filter="true"
											filterBy="code,description" appendTo="body"
											(onChange)="filtrerEntretiensCorrectifs()"
											placeholder="Sélectionner une catégorie...">
											<ng-template pTemplate="selectedItem">
												<div *ngIf="selectionCategorieEntretienCorrectifs">
													<div>{{selectionCategorieEntretienCorrectifs.code}} -
														{{selectionCategorieEntretienCorrectifs.description}}
													</div>
												</div>
											</ng-template>
											<ng-template let-categorie pTemplate="item">
												<div>
													<div>{{categorie.code}} - {{categorie.description}}</div>
												</div>
											</ng-template>
										</p-dropdown>


									</div>
								</div>

								<p-table *ngIf="chargementCompleteEntretiensCorrectifs" #dt
									[value]="entretiensCorrectifsFiltrees" [columns]="selectedColumns"
									dataKey="entretienCorrectifId" autoLayout="true" tableStyleClass="tableNormale"
									[(selection)]="selectionEntretiensCorrectifs"
									[rowHover]="true" [filterDelay]="0"
									[globalFilterFields]="['description', 'note','categorie.description','bonTravail.numero']">
									<ng-template pTemplate="caption">
										<div class="flex align-content-center justify-content-between gap-2 flex-wrap">
											<div class="flex align-items-center gap-3 flex-wrap">
												<span class="p-input-icon-left">
													<i class="pi pi-search"></i>
													<input #rechercheItem pInputText type="text"
														(input)="dt.filterGlobal($event.target.value, 'contains')"
														placeholder="Recherche..." />
												</span>
												<button
													*ngIf="estAutorise('entretien_correctif_creer') || estAutorise('temp_mec')"
													pButton pRipple icon="pi pi-plus" class="p-button-success"
													(click)="ajouterEntretienCorrectif()"></button>
												<button *ngIf="estAutorise('temp_mec')" pButton pRipple
													icon="pi pi-check-square" class="p-button-success"
													[disabled]="!selectionEntretiensCorrectifs || selectionEntretiensCorrectifs.length == 0"
													(click)="assignerEntretiensCorrectifs(selectionEntretiensCorrectifs)"></button>
											</div>
											<div>
												<h5 class="titreTableau m-0">Entretiens correctifs</h5>
											</div>

											<div>
												<p-multiSelect disabled="true" [style]="{minWidth: '200px'}"
													placeholder="Colonnes..."></p-multiSelect>
											</div>
										</div>
									</ng-template>
									<ng-template pTemplate="header" let-columns>
										<tr>
											<th style="min-width: 3rem">

											</th>
											<th pSortableColumn="etat">
												<div class="flex justify-content-between align-items-center">
													Sévérité
													<p-sortIcon field="etat"></p-sortIcon>
												</div>
											</th>
											<th pSortableColumn="description">
												<div class="flex justify-content-between align-items-center">
													Description
													<p-sortIcon field="description"></p-sortIcon>
													<p-columnFilter type="text" field="description" display="menu"
														class="ml-auto">
													</p-columnFilter>
												</div>
											</th>
											<th>
												<div class="flex justify-content-between align-items-center">
													Statut
													<p-columnFilter field="statut.nom" matchMode="in" display="menu"
														[showMatchModes]="false" [showOperator]="false"
														[showAddButton]="false">
														<ng-template pTemplate="filter" let-value
															let-filter="filterCallback">
															<p-multiSelect [ngModel]="value" [options]="filtresStatut"
																placeholder="Any" (onChange)="filter($event.value)"
																optionLabel="nom">
																<ng-template let-option pTemplate="item">
																	<div class="multiselect-representative-option">

																		<span class="ml-1">{{option}}</span>
																	</div>
																</ng-template>
															</p-multiSelect>
														</ng-template>
													</p-columnFilter>
												</div>
											</th>
											<th>
												<div class="flex justify-content-between align-items-center">
													Catégorie
													<p-columnFilter field="categorie.description" matchMode="in"
														display="menu" [showMatchModes]="false" [showOperator]="false"
														[showAddButton]="false">
														<ng-template pTemplate="filter" let-value
															let-filter="filterCallback">
															<p-multiSelect [ngModel]="value"
																[options]="filtresCategorieEntretien" placeholder="Any"
																(onChange)="filter($event.value)"
																optionLabel="description">
																<ng-template let-option pTemplate="item">
																	<div class="multiselect-representative-option">

																		<span class="ml-1">{{option}}</span>
																	</div>
																</ng-template>
															</p-multiSelect>
														</ng-template>
													</p-columnFilter>
												</div>
											</th>
											<!-- <th pSortableColumn="etat">
												<div class="flex justify-content-between align-items-center">
													Statut
													<p-sortIcon field="etat"></p-sortIcon>
												</div>
											</th>
											<th pSortableColumn="categorie.description">
												<div class="flex justify-content-between align-items-center">
													Catégorie
													<p-sortIcon field="categorie.description"></p-sortIcon>
												</div>
											</th> -->
											<th pSortableColumn="saisiPar">
												<div class="flex justify-content-between align-items-center">
													Saisi par
													<p-sortIcon field="saisiPar"></p-sortIcon>
													<p-columnFilter type="text" field="saisiPar" display="menu"
														class="ml-auto">
													</p-columnFilter>
												</div>
											</th>
											<th pSortableColumn="date">
												<div class="flex justify-content-between align-items-center">
													Date création
													<p-sortIcon field="date"></p-sortIcon>
													<p-columnFilter type="date" field="date" display="menu"
														class="ml-auto">
													</p-columnFilter>
												</div>
											</th>
											<th pSortableColumn="etat">
												<div class="flex justify-content-between align-items-center">
													No bon de travail
													<p-sortIcon field="etat"></p-sortIcon>
												</div>
											</th>
											<th pSortableColumn="bonTravail.dateTravail">
												<div class="flex justify-content-between align-items-center">
													Date BT
													<p-sortIcon field="bonTravail.dateTravail"></p-sortIcon>
													<p-columnFilter type="bonTravail.dateTravail" field="date"
														display="menu" class="ml-auto">
													</p-columnFilter>
												</div>
											</th>
											<th pSortableColumn="indPieceEnCommande">
												<div class="flex justify-content-between align-items-center">
													Pièce en commande
													<p-sortIcon field="indPieceEnCommande"></p-sortIcon>
												</div>
											</th>
											<th pSortableColumn="note">
												<div class="flex justify-content-between align-items-center">
													Note
													<p-sortIcon field="note"></p-sortIcon>
												</div>
											</th>
											<th style="min-width: 7rem; width: 7rem;"></th>

										</tr>


									</ng-template>
									<ng-template pTemplate="body" let-correctif let-columns="columns">
										<tr [pContextMenuRow]="correctif">
											<td>
												<p-tableCheckbox *ngIf="!correctif.bonTravail"
													[value]="correctif"></p-tableCheckbox>
											</td>
											<td><span
													[class]="'severite ' + correctif.severite.nom.toLowerCase().replace(' ', '')">
													{{correctif.severite.nom}}
												</span></td>
											<td>{{correctif.description}}</td>
											<td><span
													[class]="'statut ' + correctif.statut.nom.toLowerCase().replace(' ','')">
													{{correctif.statut.nom}}
												</span>
											</td>
											<td>{{correctif.categorie?.description}}</td>
											<td><app-employe-avec-emplacement
													[employe]="correctif.employe"></app-employe-avec-emplacement></td>
											<td>{{correctif.dateCreation | date:'yyyy-MM-dd'}}</td>
											<td>{{correctif.bonTravail?.numero}}</td>
											<td>{{correctif.bonTravail?.dateTravail | date:'yyyy-MM-dd'}}</td>
											<td>
												<p-checkbox [disabled]="true" [binary]="true"
													[(ngModel)]="correctif.indPieceEnCommande"></p-checkbox>
											</td>
											<td>{{correctif.note}}</td>
											<td class="celluleTableau">
												<div class="flex">
													<button pButton pRipple icon="pi pi-bars"
														class="p-button-secondary mr-2 boutonGrille"
														(click)="surMenuContextuelEntretienCorrectif($event, correctif)"></button>
												</div>
											</td>

										</tr>
									</ng-template>
									<ng-template pTemplate="emptymessage">
										<tr>
											<td colspan="12">Aucun entretien.</td>
										</tr>
									</ng-template>
								</p-table>
							</p-tabPanel>
							<!-- #endregion -->

							<!-- #region Soumissions -->
							<p-tabPanel *ngIf="estAutorise('unite_bons_travail') || estAutorise('temp_mec')"
								header="Soumissions{{nbSoumissionsEnCours == null ? ' (chargement...)' : ' (' + nbSoumissionsEnCours + ' en cours)'}}"
								leftIcon="pi pi-check-square">

								<p-card *ngIf="!chargementCompleteBonsTravail">
									<div class="fluid formgrid grid">
										<div class="flex flex-column gap-2 my-2 col-12 text-center">
											<p-progressSpinner></p-progressSpinner>
										</div>
									</div>
								</p-card>

								<p-table *ngIf="chargementCompleteBonsTravail" #dt [value]="Soumissions"
									[columns]="selectedColumns" dataKey="bonTravailId" autoLayout="true"
									tableStyleClass="tableNormale" [rowHover]="true" [rows]="100" [paginator]="true"
									[rowsPerPageOptions]="[10,25,50,100]" [filterDelay]="0"
									[globalFilterFields]="['numero','date','item.numero','item.description','mecanicien.prenomNom','contreMaitre.prenomNom']">
									<ng-template pTemplate="caption">
										<div class="flex align-content-center justify-content-between gap-2 flex-wrap">
											<div class="flex align-items-center gap-3 flex-wrap">
												<span class="p-input-icon-left">
													<i class="pi pi-search"></i>
													<input pInputText type="text"
														(input)="dt.filterGlobal($event.target.value, 'contains')"
														placeholder="Recherche..." />
												</span>
												<button
													*ngIf="estAutorise('bontravail_creer') || estAutorise('temp_mec')"
													pButton pRipple icon="pi pi-plus" class="p-button-success"
													(click)="AjouterBdt()"></button>
											</div>
											<h5 class="titreTableau m-0">Bons de travail</h5>
											<div>
												<p-multiSelect [options]="colonnesDisponibles"
													[(ngModel)]="selectedColumns" optionLabel="entete"
													selectedItemsLabel="{0} colonnes sélectionnés"
													[style]="{minWidth: '200px'}" placeholder="Colonnes...">
												</p-multiSelect>
											</div>
										</div>
									</ng-template>

									<ng-template pTemplate="header" let-columns>
										<tr>
											<th pSortableColumn="numero">
												<div class="flex justify-content-between align-items-center">
													Numéro
													<p-sortIcon field="numero"></p-sortIcon>
													<p-columnFilter type="text" field="numero" display="menu"
														class="ml-auto">
													</p-columnFilter>
												</div>
											</th>
											<th pSortableColumn="dateDebut">
												<div class="flex justify-content-between align-items-center">
													Date
													<p-sortIcon field="dateDebut"></p-sortIcon>
													<p-columnFilter type="date" field="dateDebut" display="menu"
														class="ml-auto">
													</p-columnFilter>
												</div>
											</th>
											<th pSortableColumn="item.numero">
												<div class="flex justify-content-between align-items-center">
													Unité
													<p-sortIcon field="item.numero"></p-sortIcon>
													<p-columnFilter type="text" field="item.numero" display="menu"
														class="ml-auto">
													</p-columnFilter>
												</div>
											</th>
											<th pSortableColumn="item.description">
												<div class="flex justify-content-between align-items-center">
													Description
													<p-sortIcon field="item.description"></p-sortIcon>
													<p-columnFilter type="text" field="item.description" display="menu"
														class="ml-auto">
													</p-columnFilter>
												</div>
											</th>
											<th>
												<div class="flex justify-content-between align-items-center">
													Heures / KM
												</div>
											</th>
											<th pSortableColumn="type">
												<div class="flex justify-content-between align-items-center">
													Statut
													<p-sortIcon field="type"></p-sortIcon>
													<p-columnFilter field="statut" matchMode="in" display="menu"
														[showMatchModes]="false" [showOperator]="false"
														[showAddButton]="false">
														<ng-template pTemplate="filter" let-value
															let-filter="filterCallback">
															<p-multiSelect [ngModel]="value" [options]="statuts"
																placeholder="Any" (onChange)="filter($event.value)"
																optionLabel="name">
																<ng-template let-option pTemplate="item">
																	<div class="multiselect-representative-option">

																		<span class="ml-1">{{option.nom}}</span>
																	</div>
																</ng-template>
															</p-multiSelect>
														</ng-template>
													</p-columnFilter>
												</div>
											</th>
											<th pSortableColumn="contreMaitre.prenomNom">
												<div class="flex justify-content-between align-items-center">
													Contre-Maître
													<p-sortIcon field="contreMaitre.prenomNom"></p-sortIcon>
													<p-columnFilter type="text" field="contreMaitre.prenomNom"
														display="menu" class="ml-auto">
													</p-columnFilter>
												</div>
											</th>
											<th pSortableColumn="mecanicien.prenomNom">
												<div class="flex justify-content-between align-items-center">
													Mécanicien
													<p-sortIcon field="mecanicien.prenomNom"></p-sortIcon>
													<p-columnFilter type="text" field="mecanicien.prenomNom" display="menu"
														class="ml-auto">
													</p-columnFilter>
												</div>
											</th>
											<th style="min-width: 10rem; width: 10rem;"></th>
										</tr>
									</ng-template>
									<ng-template pTemplate="body" let-bdt let-columns="columns">
										<tr>
											<td>{{bdt.numero}}</td>
											<td>{{bdt.dateTravail | date:'yyyy-MM-dd'}}</td>
											<td>{{bdt.item.numero}}</td>
											<td>{{bdt.item.description}}</td>
											<td>
												<app-ecart-releve-bt
													[heuresDebut]="bdt.heuresDebutCompteur"
													[heuresFin]="bdt.heuresCompteur"
													[kmDebut]="bdt.kmDebutCompteur"
													[kmFin]="bdt.kmCompteur"></app-ecart-releve-bt>
											</td>
											<td><span
													[class]="'statut ' + bdt.statut.nom.toLowerCase().replace(' ', '')">
													{{bdt.statut.nom}}
												</span></td>
											<td><app-employe-avec-emplacement
													[employe]="bdt.contreMaitre"></app-employe-avec-emplacement></td>
											<td><app-employe-avec-emplacement
													[employe]="bdt.mecanicien"></app-employe-avec-emplacement></td>
											<td class="celluleTableau">
												<div class="flex">
													<button
														*ngIf="estAutorise('temp_mec') || estAutorise('bonstravail')"
														pButton pRipple icon="pi pi-eye"
														class="p-button-success mr-2 boutonGrille"
														(click)="OuvrirDetailBdt(bdt.bonTravailId)"></button>
													<button
														*ngIf="estAutorise('temp_mec') || estAutorise('bonstravail')"
														pButton pRipple icon="pi pi-external-link"
														class="p-button-secondary mr-2 boutonGrille"
														(click)="OuvrirDetailBdtNouvelOnglet(bdt.bonTravailId)"></button>
													<button pButton pRipple icon="pi pi-bars"
														class="p-button-secondary mr-2 boutonGrille"
														(click)="surMenuContextuelItem($event, bdt)"></button>
												</div>
											</td>
										</tr>
									</ng-template>
									<ng-template pTemplate="emptymessage">
										<tr>
											<td colspan="6">Aucun bon de travail.</td>
										</tr>
									</ng-template>
								</p-table>

							</p-tabPanel>
							<!-- #endregion -->

							<!-- #region Bons de travail -->
							<p-tabPanel *ngIf="estAutorise('unite_bons_travail') || estAutorise('temp_mec')"
								header="Bons de travail{{nbBdtEnCours == null ? ' (chargement...)' : ' (' + nbBdtEnCours + ' en cours)'}}"
								leftIcon="pi pi-check-square">

								<p-card *ngIf="!chargementCompleteBonsTravail">
									<div class="fluid formgrid grid">
										<div class="flex flex-column gap-2 my-2 col-12 text-center">
											<p-progressSpinner></p-progressSpinner>
										</div>
									</div>
								</p-card>

								<p-table *ngIf="chargementCompleteBonsTravail" #dt [value]="BonsTravail"
									[columns]="selectedColumns" dataKey="bonTravailId" autoLayout="true"
									tableStyleClass="tableNormale" [rowHover]="true" [rows]="100" [paginator]="true"
									[rowsPerPageOptions]="[10,25,50,100]" [filterDelay]="0"
									[globalFilterFields]="['numero','date','item.numero','item.description','mecanicien.prenomNom','contreMaitre.prenomNom']">
									<ng-template pTemplate="caption">
										<div class="flex align-content-center justify-content-between">
											<div class="flex align-items-center gap-3 flex-wrap">
												<span class="p-input-icon-left">
													<i class="pi pi-search"></i>
													<input pInputText type="text"
														(input)="dt.filterGlobal($event.target.value, 'contains')"
														placeholder="Recherche..." />
												</span>
												<button
													*ngIf="estAutorise('bontravail_creer') || estAutorise('temp_mec')"
													pButton pRipple icon="pi pi-plus" class="p-button-success"
													(click)="AjouterBdt()"></button>
											</div>
											<h5 class="titreTableau m-0">Bons de travail</h5>
											<div>
												<p-multiSelect [options]="colonnesDisponibles"
													[(ngModel)]="selectedColumns" optionLabel="entete"
													selectedItemsLabel="{0} colonnes sélectionnés"
													[style]="{minWidth: '200px'}" placeholder="Colonnes...">
												</p-multiSelect>
											</div>
										</div>
									</ng-template>

									<ng-template pTemplate="header" let-columns>
										<tr>
											<th pSortableColumn="numero">
												<div class="flex justify-content-between align-items-center">
													Numéro
													<p-sortIcon field="numero"></p-sortIcon>
													<p-columnFilter type="text" field="numero" display="menu"
														class="ml-auto">
													</p-columnFilter>
												</div>
											</th>
											<th pSortableColumn="dateDebut">
												<div class="flex justify-content-between align-items-center">
													Date
													<p-sortIcon field="dateDebut"></p-sortIcon>
													<p-columnFilter type="date" field="dateDebut" display="menu"
														class="ml-auto">
													</p-columnFilter>
												</div>
											</th>
											<th pSortableColumn="item.numero">
												<div class="flex justify-content-between align-items-center">
													Unité
													<p-sortIcon field="item.numero"></p-sortIcon>
													<p-columnFilter type="text" field="item.numero" display="menu"
														class="ml-auto">
													</p-columnFilter>
												</div>
											</th>
											<th pSortableColumn="item.description">
												<div class="flex justify-content-between align-items-center">
													Description
													<p-sortIcon field="item.description"></p-sortIcon>
													<p-columnFilter type="text" field="item.description" display="menu"
														class="ml-auto">
													</p-columnFilter>
												</div>
											</th>
											<th>
												<div class="flex justify-content-between align-items-center">
													Heures / KM
												</div>
											</th>
											<th pSortableColumn="type">
												<div class="flex justify-content-between align-items-center">
													Statut
													<p-sortIcon field="type"></p-sortIcon>
													<p-columnFilter field="statut" matchMode="in" display="menu"
														[showMatchModes]="false" [showOperator]="false"
														[showAddButton]="false">
														<ng-template pTemplate="filter" let-value
															let-filter="filterCallback">
															<p-multiSelect [ngModel]="value" [options]="statuts"
																placeholder="Any" (onChange)="filter($event.value)"
																optionLabel="name">
																<ng-template let-option pTemplate="item">
																	<div class="multiselect-representative-option">

																		<span class="ml-1">{{option.nom}}</span>
																	</div>
																</ng-template>
															</p-multiSelect>
														</ng-template>
													</p-columnFilter>
												</div>
											</th>
											<th pSortableColumn="contreMaitre.prenomNom">
												<div class="flex justify-content-between align-items-center">
													Contre-Maître
													<p-sortIcon field="contreMaitre.prenomNom"></p-sortIcon>
													<p-columnFilter type="text" field="contreMaitre.prenomNom"
														display="menu" class="ml-auto">
													</p-columnFilter>
												</div>
											</th>
											<th pSortableColumn="mecanicien.prenomNom">
												<div class="flex justify-content-between align-items-center">
													Mécanicien
													<p-sortIcon field="mecanicien.prenomNom"></p-sortIcon>
													<p-columnFilter type="text" field="mecanicien.prenomNom" display="menu"
														class="ml-auto">
													</p-columnFilter>
												</div>
											</th>
											<th style="min-width: 10rem; width: 10rem;"></th>
										</tr>
									</ng-template>
									<ng-template pTemplate="body" let-bdt let-columns="columns">
										<tr>
											<td>{{bdt.numero}}</td>
											<td>{{bdt.dateTravail | date:'yyyy-MM-dd'}}</td>
											<td>{{bdt.item.numero}}</td>
											<td>{{bdt.item.description}}</td>
											<td>
												<app-ecart-releve-bt
													[heuresDebut]="bdt.heuresDebutCompteur"
													[heuresFin]="bdt.heuresCompteur"
													[kmDebut]="bdt.kmDebutCompteur"
													[kmFin]="bdt.kmCompteur"></app-ecart-releve-bt>
											</td>
											<td><span
													[class]="'statut ' + bdt.statut.nom.toLowerCase().replace(' ', '')">
													{{bdt.statut.nom}}
												</span></td>
											<td><app-employe-avec-emplacement
													[employe]="bdt.contreMaitre"></app-employe-avec-emplacement></td>
											<td><app-employe-avec-emplacement
													[employe]="bdt.mecanicien"></app-employe-avec-emplacement></td>
											<td class="celluleTableau">
												<div class="flex">
													<button
														*ngIf="estAutorise('temp_mec') || estAutorise('bonstravail')"
														pButton pRipple icon="pi pi-eye"
														class="p-button-success mr-2 boutonGrille"
														(click)="OuvrirDetailBdt(bdt.bonTravailId)"></button>
													<button
														*ngIf="estAutorise('temp_mec') || estAutorise('bonstravail')"
														pButton pRipple icon="pi pi-external-link"
														class="p-button-secondary mr-2 boutonGrille"
														(click)="OuvrirDetailBdtNouvelOnglet(bdt.bonTravailId)"></button>
													<button pButton pRipple icon="pi pi-bars"
														class="p-button-secondary mr-2 boutonGrille"
														(click)="surMenuContextuelItem($event, bdt)"></button>
												</div>
											</td>
										</tr>
									</ng-template>
									<ng-template pTemplate="emptymessage">
										<tr>
											<td colspan="6">Aucun bon de travail.</td>
										</tr>
									</ng-template>
								</p-table>

							</p-tabPanel>
							<!-- #endregion -->

							<!-- #region VADs -->
							<p-tabPanel *ngIf="estAutorise('unite_vads') || estAutorise('temp_mec')"
								header="Vérifications avant départ" leftIcon="pi pi-briefcase">


								<p-card *ngIf="!chargementCompleteVad">
									<div class="fluid formgrid grid">
										<div class="flex flex-column gap-2 my-2 col-12 text-center">
											<p-progressSpinner></p-progressSpinner>
										</div>
									</div>
								</p-card>

								<!------------ VADs ------------>

								<h3 *ngIf="chargementCompleteVad">À venir</h3>

								<!-- <p-menu #menuContextuelVads popup="popup" [model]="contenuMenuContextuelVads"></p-menu>

								<p-table *ngIf="chargementCompleteVad" #dtVads [value]="item.vads" [columns]="selectedColumns" dataKey="vadId"
									autoLayout="true" tableStyleClass="tableNormale" [(selection)]="selectionVads"
									(onRowSelect)="surChangementSelectionVads()"
									(onRowUnselect)="surChangementSelectionVads()"
									(onHeaderCheckboxToggle)="surChangementSelectionVads()"
									 [rowHover]="true" [rows]="10"
									[paginator]="true" [filterDelay]="0" [globalFilterFields]="['description']">
									<ng-template pTemplate="caption">
										<div class="flex align-content-center justify-content-between">
											<div>
												<span class="p-input-icon-left">
													<i class="pi pi-search"></i>
													<input #rechercheVad pInputText type="text"
														(input)="dtVads.filterGlobal($event.target.value, 'contains')"
														(keyup.enter)="surEntreeRechercheCorrectifs()"
														placeholder="Recherche..." />
												</span>
											</div>
											<div>
												<h5 class="titreTableau m-0">Vérifications avant départ</h5>
											</div>

											<div>
												<p-multiSelect disabled="true" [style]="{minWidth: '200px'}"
													placeholder="Colonnes..."></p-multiSelect>
											</div>
										</div>
									</ng-template>
									<ng-template pTemplate="header" let-columns>
										<tr>
											<th pSortableColumn="date">
												<div class="flex justify-content-between align-items-center">
													Date
													<p-sortIcon field="date"></p-sortIcon>
													<p-columnFilter type="date" field="date" display="menu"
														class="ml-auto">
													</p-columnFilter>
												</div>
											</th>
											<th pSortableColumn="description">
												<div class="flex justify-content-between align-items-center">
													Description
													<p-sortIcon field="description"></p-sortIcon>
													<p-columnFilter type="text" field="description" display="menu"
														class="ml-auto">
													</p-columnFilter>
												</div>
											</th>
											<th pSortableColumn="saisiPar">
												<div class="flex justify-content-between align-items-center">
													Chauffeur
													<p-sortIcon field="saisiPar"></p-sortIcon>
													<p-columnFilter type="text" field="saisiPar" display="menu"
														class="ml-auto">
													</p-columnFilter>
												</div>
											</th>
											<th pSortableColumn="date">
												<div class="flex justify-content-between align-items-center">
													Statut
													<p-sortIcon field="date"></p-sortIcon>
													<p-columnFilter type="date" field="date" display="menu"
														class="ml-auto">
													</p-columnFilter>
												</div>
											</th>
											<th pSortableColumn="saisiPar">
												<div class="flex justify-content-between align-items-center">
													Nb total points
													<p-sortIcon field="saisiPar"></p-sortIcon>
													<p-columnFilter type="text" field="saisiPar" display="menu"
														class="ml-auto">
													</p-columnFilter>
												</div>
											</th>
											<th pSortableColumn="saisiPar">
												<div class="flex justify-content-between align-items-center">
													Nb points défecteux
													<p-sortIcon field="saisiPar"></p-sortIcon>
													<p-columnFilter type="text" field="saisiPar" display="menu"
														class="ml-auto">
													</p-columnFilter>
												</div>
											</th>
											<th pSortableColumn="saisiPar">
												<div class="flex justify-content-between align-items-center">
													Note
													<p-sortIcon field="saisiPar"></p-sortIcon>
													<p-columnFilter type="text" field="saisiPar" display="menu"
														class="ml-auto">
													</p-columnFilter>
												</div>
											</th>

											<th style="min-width: 7rem; width: 7rem;"></th>

										</tr>


									</ng-template>
									<ng-template pTemplate="body" let-vad let-columns="columns">
										<tr [pContextMenuRow]="correctif">
											<td>{{vad.date | date:'yyyy-MM-dd HH:mm:ss'}}</td>
											<td>{{vad.description}}</td>
											<td>{{vad.chauffeur}}</td>
											<td><span
													[class]="'statut ' + vad.statut.nom.toLowerCase().replace(' ','')">
													{{vad.statut.nom}}
												</span>
											</td>

											<td>{{vad.nbItems}}</td>
											<td>{{vad.nbDefauts}}</td>
											<td>{{vad.notes}}</td>

											<td class="celluleTableau flex">
												<button *ngIf="estAutorise('temp_mec')" pButton pRipple
													icon="pi pi-eye" class="p-button-success mr-2 boutonGrille"
													(click)="ouvrirDetailVad(vad)"></button>
												
												<button pButton pRipple icon="pi pi-bars"
													class="p-button-secondary mr-2 boutonGrille"
													(click)="surMenuContextuelVad($event, vad)"></button>
											</td>

										</tr>
									</ng-template>
									<ng-template pTemplate="emptymessage">
										<tr>
											<td colspan="8">Aucune vérification avant départ.</td>
										</tr>
									</ng-template>
								</p-table> -->



							</p-tabPanel>
							<!-- #endregion -->

							<!-- #region Pièces -->
							<p-tabPanel *ngIf="estAutorise('unite_pieces') || estAutorise('temp_mec')" header="Pièces"
								leftIcon="pi pi-briefcase">

								<p-card *ngIf="!chargementCompletePieces">
									<div class="fluid formgrid grid">
										<div class="flex flex-column gap-2 my-2 col-12 text-center">
											<p-progressSpinner></p-progressSpinner>
										</div>
									</div>
								</p-card>


								<p-menu #menuContextuelPieces popup="popup" [model]="contenuMenuContextuelPieces">
								</p-menu>

								<p-table *ngIf="chargementCompletePieces" #dtPieces [value]="piecesFiltrees"
									[columns]="selectedColumns" dataKey="pieceUniteId" autoLayout="true"
									tableStyleClass="tableNormale" [rowHover]="true" [filterDelay]="0"
									[globalFilterFields]="['piece.numero','piece.description','piece.modele','piece.marque','categorieEntretien.code','categorieEntretien.description']">
									<ng-template pTemplate="caption">
										<div class="flex flex-wrap align-content-center justify-content-between gap-2">
											<div class="flex gap-2 align-items-center">
												<span class="p-input-icon-left">
													<i class="pi pi-search"></i>
													<input #rechercheItem pInputText type="text"
														(input)="dtPieces.filterGlobal($event.target.value, 'contains')"
														placeholder="Recherche..." />
												</span>
												<p-dropdown [options]="listeCategoriesEntretien"
													[(ngModel)]="selectionCategorieEntretien" [showClear]="true"
													optionLabel="description" [showClear]="true" filter="true"
													filterBy="code,description" appendTo="body"
													(onChange)="filtrerPieces()"
													placeholder="Sélectionner une catégorie...">
													<ng-template pTemplate="selectedItem">
														<div *ngIf="selectionCategorieEntretien">
															<div>{{selectionCategorieEntretien.code}} -
																{{selectionCategorieEntretien.description}}
															</div>
														</div>
													</ng-template>
													<ng-template let-categorie pTemplate="item">
														<div>
															<div>{{categorie.code}} - {{categorie.description}}</div>
														</div>
													</ng-template>
												</p-dropdown>
												<button *ngIf="estAutorise('piece_associer') || estAutorise('temp_mec')"
													pButton pRipple icon="pi pi-plus" class="p-button-success"
													(click)="ajouterPiece()"></button>
											</div>
											<div>
												<h5 class="titreTableau m-0">Pièces</h5>
											</div>

											<div>
												<p-multiSelect disabled="true" [style]="{minWidth: '200px'}"
													placeholder="Colonnes..."></p-multiSelect>
											</div>
										</div>
									</ng-template>
									<ng-template pTemplate="header" let-columns>
										<tr>
											<th pSortableColumn="categorieEntretien.code">
												<div class="flex justify-content-between align-items-center">
													Catégorie
													<p-sortIcon field="categorieEntretien.code"></p-sortIcon>
													<p-columnFilter type="text" field="categorieEntretien.code"
														display="menu" class="ml-auto">
													</p-columnFilter>
												</div>
											</th>
											<th pSortableColumn="piece.numero">
												<div class="flex justify-content-between align-items-center">
													Numéro
													<p-sortIcon field="piece.numero"></p-sortIcon>
													<p-columnFilter type="text" field="piece.numero" display="menu"
														class="ml-auto">
													</p-columnFilter>
												</div>
											</th>
											<th pSortableColumn="piece.description">
												<div class="flex justify-content-between align-items-center">
													Description
													<p-sortIcon field="piece.description"></p-sortIcon>
													<p-columnFilter type="text" field="piece.description" display="menu"
														class="ml-auto">
													</p-columnFilter>
												</div>
											</th>
											<th pSortableColumn="piece.marque">
												<div class="flex justify-content-between align-items-center">
													Marque
													<p-sortIcon field="piece.marque"></p-sortIcon>
													<p-columnFilter type="text" field="piece.marque" display="menu"
														class="ml-auto">
													</p-columnFilter>
												</div>
											</th>
											<th pSortableColumn="piece.modele">
												<div class="flex justify-content-between align-items-center">
													Modèle
													<p-sortIcon field="piece.modele"></p-sortIcon>
													<p-columnFilter type="text" field="piece.modele" display="menu"
														class="ml-auto">
													</p-columnFilter>
												</div>
											</th>
											<th pSortableColumn="piece.description">
												<div class="flex justify-content-between align-items-center">
													Fournisseur principal
													<p-sortIcon field="piece.description"></p-sortIcon>
													<p-columnFilter type="text" field="piece.description" display="menu"
														class="ml-auto">
													</p-columnFilter>
												</div>
											</th>
											<th pSortableColumn="piece.produitsFournisseurChaine">
												<div class="flex justify-content-between align-items-center">
													No Pièce Fournisseur
													<p-sortIcon field="piece.produitsFournisseurChaine"></p-sortIcon>
													<p-columnFilter type="text" field="piece.produitsFournisseurChaine"
														display="menu" class="ml-auto">
													</p-columnFilter>
												</div>
											</th>
											<th pSortableColumn="note">
												<div class="flex justify-content-between align-items-center">
													Note
													<p-sortIcon field="note"></p-sortIcon>
													<p-columnFilter type="text" field="note" display="menu"
														class="ml-auto">
													</p-columnFilter>
												</div>
											</th>
											<th style="min-width: 7rem; width: 7rem;"></th>
										</tr>
									</ng-template>
									<ng-template pTemplate="body" let-piece let-columns="columns">
										<tr>
											<td>{{piece.categorieEntretien?.code}} -
												{{piece.categorieEntretien?.description}}</td>
											<td>{{piece.piece.numero}}</td>
											<td>{{piece.piece.description}}</td>
											<td>{{piece.piece.marque}}</td>
											<td>{{piece.piece.modele}}</td>
											<td *ngIf="piece.fournisseurPrincipal">
												{{piece.fournisseurPrincipal?.nom}}
												({{piece.fournisseurPrincipal?.code}})
											</td>
											<td *ngIf="!piece.fournisseurPrincipal"></td>
											<td style="white-space: pre-line;">{{piece.piece.produitsFournisseurChaine}}
											</td>
											<td>{{piece.note}}</td>
											<td class="celluleTableau">
												<div class="flex">
													<button pButton pRipple icon="pi pi-bars"
														class="p-button-secondary mr-2 boutonGrille"
														(click)="surMenuContextuelPiece($event, piece)"></button>
												</div>
											</td>
										</tr>
									</ng-template>
									<ng-template pTemplate="emptymessage">
										<tr>
											<td colspan="7">Aucune pièce.</td>
										</tr>
									</ng-template>
								</p-table>




							</p-tabPanel>
							<!-- #endregion -->

							<!-- #region Historique achats -->
							<p-tabPanel *ngIf="estAutorise('temp_mec') || estAutorise('unite_historique_achat')"
								header="Historique d'achat de pièces" leftIcon="pi pi-dollar">
								<p-menu #menuContextuelHistoriqueAchatPieces popup="popup"
									[model]="contenuMenuContextuelHistoriqueAchatPieces"></p-menu>

								<p-card *ngIf="!chargementCompleteHistoriqueAchatPieces">
									<div class="fluid formgrid grid">
										<div class="flex flex-column gap-2 my-2 col-12 text-center">
											<p-progressSpinner></p-progressSpinner>
										</div>
									</div>
								</p-card>
								<p-table *ngIf="chargementCompleteHistoriqueAchatPieces" #dtHistoriqueAchatPieces
									tableStyleClass="tableNormale" [value]="item.value().historiqueAchatPieces"
									autoLayout="true" dataKey="id" [globalFilterFields]="['bonCommande.numero']">
									<!-- <ng-template pTemplate="caption">
										<div class="flex p-flex-column p-flex-md-row p-jc-md-between table-header">
											<span class="p-input-icon-left">
												<i class="pi pi-search"></i>
												<input pInputText type="text"
													(input)="dtHistoriqueAchatPieces.filterGlobal($event.target.value, 'contains')"
													placeholder="Recherche..." />
											</span>
										</div>
									</ng-template> -->
									<ng-template pTemplate="header">
										<tr>
											<th pSortableColumn="item.numero">
												<div class="flex justify-content-between align-items-center">
													Numéro
													<p-sortIcon field="item.numero"></p-sortIcon>
													<p-columnFilter type="text" field="item.numero" display="menu"
														class="ml-auto">
													</p-columnFilter>
												</div>
											</th>
											<th pSortableColumn="item.description">
												<div class="flex justify-content-between align-items-center">
													Description
													<p-sortIcon field="item.description"></p-sortIcon>
													<p-columnFilter type="text" field="item.description" display="menu"
														class="ml-auto">
													</p-columnFilter>
												</div>
											</th>
											<th pSortableColumn="item.marque">
												<div class="flex justify-content-between align-items-center">
													Marque
													<p-sortIcon field="item.marque"></p-sortIcon>
													<p-columnFilter type="text" field="item.marque" display="menu"
														class="ml-auto">
													</p-columnFilter>
												</div>
											</th>
											<th pSortableColumn="item.modele">
												<div class="flex justify-content-between align-items-center">
													Modèle
													<p-sortIcon field="item.modele"></p-sortIcon>
													<p-columnFilter type="text" field="item.modele" display="menu"
														class="ml-auto">
													</p-columnFilter>
												</div>
											</th>
											<th pSortableColumn="bonCommande.numero">
												<div class="flex justify-content-between align-items-center">
													No BDC
													<p-sortIcon field="bonCommande.numero"></p-sortIcon>
													<p-columnFilter type="text" field="bonCommande.numero"
														display="menu" class="ml-auto">
													</p-columnFilter>
												</div>
											</th>
											<th pSortableColumn="bonCommande.dateAchat">
												<div class="flex justify-content-between align-items-center">
													Date
													<p-sortIcon field="bonCommande.dateAchat"></p-sortIcon>
													<p-columnFilter type="date" field="bonCommande.dateAchat"
														display="menu" class="ml-auto">
													</p-columnFilter>
												</div>
											</th>
											<th>
												<div class="flex justify-content-between align-items-center">
													Statut
												</div>
											</th>

											<th pSortableColumn="bonCommande.fournisseur.nom">
												<div class="flex justify-content-between align-items-center">
													Fournisseur
													<p-sortIcon field="bonCommande.fournisseur.nom"></p-sortIcon>
													<p-columnFilter type="text" field="bonCommande.fournisseur.nom"
														display="menu" class="ml-auto">
													</p-columnFilter>
												</div>
											</th>
											<th pSortableColumn="quantite">
												<div class="flex justify-content-between align-items-center">
													Quantité
													<p-sortIcon field="quantite"></p-sortIcon>
													<p-columnFilter type="number" field="quantite" display="menu"
														class="ml-auto">
													</p-columnFilter>
												</div>
											</th>
											<th pSortableColumn="prix">
												<div class="flex justify-content-between align-items-center">
													Prix
													<p-sortIcon field="prix"></p-sortIcon>
													<p-columnFilter type="text" field="prix" display="menu"
														class="ml-auto">
													</p-columnFilter>
												</div>
											</th>
											<th *ngIf="!modeApercu" style="min-width: 5rem;"></th>
										</tr>
									</ng-template>
									<ng-template pTemplate="body" let-achat>
										<tr [pContextMenuRow]="achat">
											<td>{{achat.item.numero}}
											</td>
											<td>{{achat.item.description}}</td>

											<td>
												{{achat.item.marque}}
											</td>
											<td>
												{{achat.item.modele}}
											</td>
											<td>
												{{achat.bonCommande.numero}}
											</td>
											<td>
												{{achat.bonCommande.dateAchat | date:'yyyy-MM-dd'}}
											</td>
											<td>
												<span
													[class]="'statut ' + achat.bonCommande.statut.nom.toLowerCase().replace(' ','')">
													{{achat.bonCommande.statut.nom}}
												</span>
											</td>
											<td>
												{{achat.bonCommande.fournisseur.nom}}
												({{achat.bonCommande.fournisseur.numero}})
											</td>
											<td>
												{{achat.quantite}}
											</td>
											<td>
												{{achat.prix | currency}}
											</td>
											<td *ngIf="!modeApercu">
												<button
													*ngIf="estAutorise('bdc_detail') || estAutorise('fournisseur_detail') || estAutorise('bdc_creer')"
													pButton pRipple icon="pi pi-bars"
													class="p-button-secondary mr-2 boutonGrille"
													(click)="surMenuContextuelHistoriqueAchatPieces($event, achat)"></button>
											</td>
										</tr>
									</ng-template>
									<ng-template pTemplate="emptymessage">
										<tr>
											<td colspan="8">Aucun historique.</td>
										</tr>
									</ng-template>
								</p-table>
							</p-tabPanel>
							<!-- #endregion -->

							<!-- #region Historique envoi -->
							<p-tabPanel *ngIf="estAutorise('temp_mec') || estAutorise('unite_historique_envoi')"
								header="Historique d'envoi de pièces" leftIcon="pi pi-calendar">
								<p-menu #menuContextuelHistoriquePieces popup="popup"
									[model]="contenuMenuContextuelHistoriquePieces"></p-menu>

								<p-card *ngIf="!chargementCompleteHistoriquePieces">
									<div class="fluid formgrid grid">
										<div class="flex flex-column gap-2 my-2 col-12 text-center">
											<p-progressSpinner></p-progressSpinner>
										</div>
									</div>
								</p-card>

								<p-table *ngIf="chargementCompleteHistoriquePieces" #dtHistoriquePieces
									tableStyleClass="tableNormale" [value]="item.value().historiquePieces"
									autoLayout="true" dataKey="id"
									[globalFilterFields]="['requisition.numero','requisition.de.code','requisition.de.nom','requisition.a.code', 'requisition.a.nom', 'requisition.demandeur']">
									<ng-template pTemplate="caption">
										<div class="flex p-flex-column p-flex-md-row p-jc-md-between table-header">
											<span class="p-input-icon-left">
												<i class="pi pi-search"></i>
												<input pInputText type="text"
													(input)="dtHistoriquePieces.filterGlobal($event.target.value, 'contains')"
													placeholder="Recherche..." />
											</span>
										</div>
									</ng-template>
									<ng-template pTemplate="header">
										<tr>
											<th pSortableColumn="itemRequisition.item.numero">
												<div class="flex justify-content-between align-items-center">
													No pièce
													<p-sortIcon field="itemRequisition.item.numero"></p-sortIcon>
													<p-columnFilter type="text" field="itemRequisition.item.numero"
														display="menu" class="ml-auto">
													</p-columnFilter>
												</div>
											</th>
											<th pSortableColumn="itemRequisition.item.description">
												<div class="flex justify-content-between align-items-center">
													Description
													<p-sortIcon field="itemRequisition.item.description"></p-sortIcon>
													<p-columnFilter type="text" field="itemRequisition.item.description"
														display="menu" class="ml-auto">
													</p-columnFilter>
												</div>
											</th>
											<th pSortableColumn="itemRequisition.item.marque">
												<div class="flex justify-content-between align-items-center">
													Marque
													<p-sortIcon field="itemRequisition.item.marque"></p-sortIcon>
													<p-columnFilter type="text" field="itemRequisition.item.marque"
														display="menu" class="ml-auto">
													</p-columnFilter>
												</div>
											</th>
											<th pSortableColumn="itemRequisition.item.modele">
												<div class="flex justify-content-between align-items-center">
													Modèle
													<p-sortIcon field="itemRequisition.item.modele"></p-sortIcon>
													<p-columnFilter type="text" field="itemRequisition.item.modele"
														display="menu" class="ml-auto">
													</p-columnFilter>
												</div>
											</th>
											<th pSortableColumn="requisition.numero">
												<div class="flex justify-content-between align-items-center">
													No réquisition
													<p-sortIcon field="requisition.numero"></p-sortIcon>
													<p-columnFilter type="text" field="requisition.numero"
														display="menu" class="ml-auto">
													</p-columnFilter>
												</div>
											</th>
											<th pSortableColumn="requisition.date">
												<div class="flex justify-content-between align-items-center">
													Date
													<p-sortIcon field="requisition.date"></p-sortIcon>
													<p-columnFilter type="requisition.date" field="date" display="menu"
														class="ml-auto">
													</p-columnFilter>
												</div>
											</th>

											<th pSortableColumn="requisition.a.nom">
												<div class="flex justify-content-between align-items-center">
													Endroit
													<p-sortIcon field="requisition.a.nom"></p-sortIcon>
													<p-columnFilter type="text" field="requisition.a.nom" display="menu"
														class="ml-auto">
													</p-columnFilter>
												</div>
											</th>
											<th pSortableColumn="requisition.quantite">
												<div class="flex justify-content-between align-items-center">
													Quantité
													<p-sortIcon field="requisition.quantite"></p-sortIcon>
													<p-columnFilter type="text" field="requisition.quantite"
														display="menu" class="ml-auto">
													</p-columnFilter>
												</div>
											</th>
											<th *ngIf="!modeApercu" style="min-width: 5rem; width: 5rem;"></th>
										</tr>
									</ng-template>
									<ng-template pTemplate="body" let-historique>
										<tr [pContextMenuRow]="historique">
											<td>
												{{historique.itemRequisition.item.numero}}
											</td>
											<td>
												{{historique.itemRequisition.item.description}}
											</td>
											<td>
												{{historique.itemRequisition.item.marque}}
											</td>
											<td>
												{{historique.itemRequisition.item.modele}}
											</td>
											<td>
												{{historique.requisition.numero}}
											</td>
											<td>
												{{historique.requisition.date | date:'yyyy-MM-dd'}}
											</td>
											<td>
												{{historique.requisition.a.nom}} ({{historique.requisition.a.code}})
											</td>
											<td>
												{{historique.quantite}}
											</td>
											<td *ngIf="!modeApercu">
												<button *ngIf="estAutorise('temp_mec')" pButton pRipple
													icon="pi pi-bars" class="p-button-secondary mr-2 boutonGrille"
													(click)="surMenuContextuelHistoriquePieces($event, historique)"></button>
											</td>
										</tr>
									</ng-template>
									<ng-template pTemplate="emptymessage">
										<tr>
											<td colspan="6">Aucun historique.</td>
										</tr>
									</ng-template>
								</p-table>
							</p-tabPanel>
							<!-- #endregion -->

						</p-tabView>

					</div>

					</p-card>
				</p-tabPanel>
				<!-- #endregion -->
				<!-- #region Notes  -->
				<p-tabPanel *ngIf="estAutorise('item_notes')" [header]="'Notes (' + item.value().nbEntreesNotes + ')'"
					leftIcon="pi pi-pencil">
					<p-card>
					<p-menu #menuContextuelNote popup="popup" [model]="contenuMenuContextuelNote"></p-menu>

					<p-card *ngIf="!chargementCompleteNotes">
						<div class="fluid formgrid grid">
							<div class="flex flex-column gap-2 my-2 col-12 text-center">
								<p-progressSpinner></p-progressSpinner>
							</div>
						</div>
					</p-card>

					<div *ngIf="chargementCompleteNotes">
						<p-table #dtNotes [value]="item.value().notes" dataKey="noteId" tableStyleClass="tableNormale"
							autoLayout="true" [rowHover]="true" [filterDelay]="0"
							[globalFilterFields]="['description']">
							<ng-template pTemplate="caption">
								<div class="flex align-content-center justify-content-between">
									<div>
										<span class="p-input-icon-left">
											<i class="pi pi-search"></i>
											<input pInputText type="text"
												(input)="dtNotes.filterGlobal($event.target.value, 'contains')"
												placeholder="Recherche..." />
										</span>
										<button *ngIf="estAutorise('item_note_creer') && !modeApercu" pButton pRipple
											icon="pi pi-plus" class="p-button-success mr-2 ml-4 mb-2 boutonGrille"
											(click)="ajouterNote()"></button>

									</div>
									<h5 class="titreTableau m-0">Notes</h5>
									<div>
										<p-multiSelect disabled="true" [style]="{minWidth: '200px'}"
											placeholder="Colonnes..."></p-multiSelect>
									</div>
								</div>
							</ng-template>
							<ng-template pTemplate="header">
								<tr>
									<th pSortableColumn="date">
										<div class="flex justify-content-between align-items-center">
											Date
											<p-sortIcon field="date"></p-sortIcon>
											<p-columnFilter type="date" field="date" display="menu" class="ml-auto">
											</p-columnFilter>
										</div>
									</th>
									<th pSortableColumn="description">
										<div class="flex justify-content-between align-items-center">
											Note
											<p-sortIcon field="description"></p-sortIcon>
											<p-columnFilter type="text" field="description" display="menu"
												class="ml-auto">
											</p-columnFilter>
										</div>
									</th>
									<th pSortableColumn="demandeur.nom">
										<div class="flex justify-content-between align-items-center">
											Auteur
											<p-sortIcon field="demandeur"></p-sortIcon>
											<p-columnFilter type="text" field="demandeur" display="menu"
												class="ml-auto">
											</p-columnFilter>
										</div>
									</th>
									<th *ngIf="!modeApercu" style="min-width: 5rem"></th>
								</tr>
							</ng-template>
							<ng-template pTemplate="body" let-note>

								<tr>
									<td>{{note.date | date:'yyyy-MM-dd'}}</td>
									<td>{{note.description}}</td>
									<td><app-employe-avec-emplacement
											[employe]="note.employe"></app-employe-avec-emplacement></td>
									<td *ngIf="!modeApercu">
										<button
											*ngIf="estAutorise('item_note_modifier') || estAutorise('item_note_supprimer')"
											pButton pRipple icon="pi pi-bars"
											class="p-button-secondary mr-2 boutonGrille"
											(click)="surMenuContextuelNote($event, note)"></button>
									</td>
								</tr>
							</ng-template>
							<ng-template pTemplate="emptymessage">
								<tr>
									<td colspan="4">Aucune note.</td>
								</tr>
							</ng-template>
						</p-table>
					</div>
					</p-card>
				</p-tabPanel>
				<!-- #endregion -->
			</p-tabView>

	</div>


</div>

<!-- #region Dialogues -->

<!-- ##########   DIALOGUE IMPRESSION   ########## -->

<p-dialog [(visible)]="dialogueImpression" [style]="{width: '20%'}" header="Options d'impression" [modal]="true"
	[contentStyle]="{'overflow': 'visible'}" styleClass="fluid formgrid grid">
	<ng-template pTemplate="content">

		<div class="formgrid grid">
			<div class="flex flex-column gap-2 my-2 col-12 md:col-6" style="vertical-align: top;">
				<button pButton pRipple label="Sélectionner tout" class="p-button-text"
					(click)="selectionnerTout()"></button>
			</div>
			<div class="flex flex-column gap-2 my-2 col-12 md:col-6" style="vertical-align: top;">
				<button pButton pRipple label="Désélectionner tout" class="p-button-text"
					(click)="deselectionnerTout()"></button>
			</div>
			<div class="flex flex-column gap-2 my-2 col-12" style="vertical-align: top;">
				<p-checkbox label="Identification" [binary]="true" [(ngModel)]="optionsImpression.identification"
					disabled="true"></p-checkbox>
			</div>
			<div class="flex flex-column gap-2 my-2 col-12" style="vertical-align: top;">
				<p-checkbox label="Attributs supplémentaires" [binary]="true" [(ngModel)]="optionsImpression.attributs"
					disabled="true"></p-checkbox>
			</div>
			<div class="flex flex-column gap-2 my-2 col-12" style="vertical-align: top;">
				<p-checkbox label="Historique" [binary]="true" [(ngModel)]="optionsImpression.historique"></p-checkbox>
			</div>
			<div class="flex flex-column gap-2 my-2 col-12" style="vertical-align: top;">
				<p-checkbox [disabled]="item.value().categorie.estUnique == true" label="Inventaire" [binary]="true"
					[(ngModel)]="optionsImpression.inventaire"></p-checkbox>
			</div>
			<div class="flex flex-column gap-2 my-2 col-12" style="vertical-align: top;">
				<p-checkbox [disabled]="item.value().categorie.estUnique == true" label="Fournisseurs" [binary]="true"
					[(ngModel)]="optionsImpression.fournisseurs">
				</p-checkbox>
			</div>
			<div class="flex flex-column gap-2 my-2 col-12" style="vertical-align: top;">
				<p-checkbox [disabled]="item.value().categorie.estUnique == true" label="Achats" [binary]="true"
					[(ngModel)]="optionsImpression.achats"></p-checkbox>
			</div>
			<div class="flex flex-column gap-2 my-2 col-12" style="vertical-align: top;">
				<p-checkbox [disabled]="item.value().categorie.estUnique == false" label="Liaisons" [binary]="true"
					[(ngModel)]="optionsImpression.liaisons"></p-checkbox>
			</div>
			<div class="flex flex-column gap-2 my-2 col-12" style="vertical-align: top;">
				<p-checkbox [disabled]="item.value().categorie.estUnique == false" label="Garanties" [binary]="true"
					[(ngModel)]="optionsImpression.garanties"></p-checkbox>
			</div>
			<div class="flex flex-column gap-2 my-2 col-12" style="vertical-align: top;">
				<p-checkbox label="Notes" [binary]="true" [(ngModel)]="optionsImpression.notes"></p-checkbox>
			</div>

		</div>

	</ng-template>

	<ng-template pTemplate="footer">
		<button pButton pRipple label="Annuler" icon="pi pi-times" class="p-button-text"
			(click)="annulerImpression()"></button>
		<button pButton pRipple label="Confirmer" icon="pi pi-check" class="p-button-text"
			(click)="imprimer()"></button>
	</ng-template>
</p-dialog>



<!-- ##########   DIALOGUE DÉTAIL GARANTIE   ########## -->

<p-blockUI [blocked]="dialogueGarantieBloque">
	<div class="fluid formgrid grid">
		<div class="flex flex-column gap-2 my-2 col-12 text-center">
			<p-progressSpinner></p-progressSpinner>
		</div>
	</div>
</p-blockUI>

<p-dialog #dialogueGarantie [(visible)]="dialogueGarantieOuvert" [style]="{width: '85%'}" header="Détail de la garantie"
	[modal]="true" styleClass="fluid formgrid grid">
	<ng-template pTemplate="content">
		<div class="fluid formgrid grid">
			<div class="flex flex-column gap-2 my-2 col-12 md:col-6 lg:col-3">
				<label for="type">Type de garantie<span class="requis">*</span></label>
				<p-dropdown appendTo="body" [options]="typesGarantie" [(ngModel)]="garantie.type" optionLabel="nom"
					[filter]="true" [style]="{'width':'100%'}" filterBy="nom,prenom" [showClear]="true"
					placeholder="Selectionnez un type de garantie...">
					<ng-template pTemplate="selectedItem">
						<div *ngIf="garantie.type">
							<div>{{garantie.type.nom}}</div>
						</div>
					</ng-template>
					<ng-template let-type pTemplate="item">
						<div>
							<div>{{type.nom}}</div>
						</div>
					</ng-template>
				</p-dropdown>
				<small class="p-error" *ngIf="grantieSubmitted && !garantie.type">Le type de garantie est
					obligatoire.</small>
			</div>

			<div class="flex flex-column gap-2 my-2 col-12 md:col-6 lg:col-3">
				<label for="lastname">Date de début<span class="requis">*</span></label>
				<p-calendar showIcon=true [(ngModel)]="garantie.dateDebut" dateFormat="yy-mm-dd" [yearNavigator]="true"
					[monthNavigator]="true" yearRange="2000:2040" appendTo="body">
				</p-calendar>
				<small class="p-error" *ngIf="grantieSubmitted && !garantie.dateDebut">La date de début est
					obligatoire.</small>
			</div>
			<div class="flex flex-column gap-2 my-2 col-12 md:col-6 lg:col-3">
				<label for="lastname">Date fin<span class="requis">*</span></label>
				<i *ngIf="garantie.dateDebut" class="pi pi-question-circle ml-3" style="font-size: 1rem"
					(click)="selectionnerDelai()"></i>
				<p-calendar showIcon=true [(ngModel)]="garantie.dateFin" dateFormat="yy-mm-dd" [yearNavigator]="true"
					[monthNavigator]="true" yearRange="2000:2040" appendTo="body">
				</p-calendar>
				<small class="p-error" *ngIf="grantieSubmitted && !garantie.dateFin">La date de fin est
					obligatoire.</small>
			</div>
		</div>
		<div class="fluid formgrid grid">
			<div class="flex flex-column gap-2 my-2 col-12">
				<label for="description">Description</label>
				<input type="text" pInputText id="description" [(ngModel)]="garantie.description" autocomplete="off" />
			</div>

		</div>

	</ng-template>

	<ng-template pTemplate="footer">
		<button pButton pRipple label="Enregistrer" icon="pi pi-save" class="p-button-primary"
			(click)="sauvegarderGarantie()"></button>
		<button pButton pRipple label="Annuler" icon="pi pi-ban" class="p-button-text"
			(click)="annulerGarantie()"></button>

	</ng-template>
</p-dialog>


<!-- ##########   DIALOGUE DÉTAIL NOTE   ########## -->

<p-blockUI [blocked]="dialogueNoteBloque">
	<div class="fluid formgrid grid">
		<div class="flex flex-column gap-2 my-2 col-12 text-center">
			<p-progressSpinner></p-progressSpinner>
		</div>
	</div>
</p-blockUI>

<p-dialog #dialogueNote [(visible)]="dialogueNoteOuvert" [style]="{width: '85%'}" header="Détail de la note"
	[modal]="true" styleClass="fluid formgrid grid">
	<ng-template pTemplate="content">
		<div class="fluid formgrid grid">
			<div class="flex flex-column gap-2 my-2 col-12">
				<label for="description">Description</label>
				<!-- 	<input  type="text" pInputText id="description" [(ngModel)]="note.description"
				autocomplete="off"  /> -->
				<textarea #champNote pInputTextarea noLinkFormat [(ngModel)]="note.description" autocomplete="off"
					autoResize="autoResize"></textarea>
			</div>
		</div>
	</ng-template>

	<ng-template pTemplate="footer">
		<button pButton pRipple label="Enregistrer" icon="pi pi-save" class="p-button-primary"
			(click)="sauvegarderNote()"></button>
		<button pButton pRipple label="Annuler" icon="pi pi-ban" class="p-button-text" (click)="annulerNote()"></button>

	</ng-template>
</p-dialog>
<!-- #endregion -->

<p-sidebar [(visible)]="afficherDetailBdc" [style]="{width:'95%'}" position="left">
	<app-detail-bdc [bdcId]="detailBdcId" *ngIf="afficherDetailBdc"></app-detail-bdc>
</p-sidebar>